// import React, { useEffect, useRef, useState } from "react";
// import { API } from "../config/api";
// import { post } from "../lib/http";
// import {
//   FaPlus,
//   FaTrash,
//   FaSpinner,
//   FaCheckCircle,
//   FaTimesCircle,
//   FaUpload,
//   FaImage,
//   FaMapMarkerAlt,
//   FaCrosshairs,
//   FaSearch,
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import RichText from "../admin/pages/events/RichText.jsx";
// import { User } from "lucide-react";

// /* --------------------------- helpers --------------------------- */
// const toDTLocal = (d) => {
//   const pad = (n) => String(n).padStart(2, "0");
//   return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
//     d.getHours()
//   )}:${pad(d.getMinutes())}`;
// };
// const cn = (...a) => a.filter(Boolean).join(" ");
// const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
// const MAX_IMG_MB = 5;

// // Small debounce hook for typeahead
// function useDebouncedValue(value, ms = 300) {
//   const [v, setV] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setV(value), ms);
//     return () => clearTimeout(t);
//   }, [value, ms]);
//   return v;
// }

// // Nominatim helpers (free; please keep requests light to respect usage policy)
// const NOMINATIM_BASE = "https://nominatim.openstreetmap.org";

// // normalize nominatim -> our venue shape
// function normalizeAddress(osm) {
//   const a = osm?.address || {};
//   const city = a.city || a.town || a.village || a.hamlet || "";
//   const state = a.state || a.region || "";
//   const country = a.country || "";
//   const pincode = a.postcode || "";
//   const name = a.neighbourhood || a.suburb || a.quarter || a.road || a.residential || "";
//   // "address" field we’ll store as display_name (human friendly, editable)
//   const address = osm?.display_name || "";
//   return {
//     name,
//     address,
//     city,
//     state,
//     country,
//     pincode,
//     latitude: String(osm?.lat || ""),
//     longitude: String(osm?.lon || ""),
//   };
// }

// async function nominatimSearch(q, { limit = 5, lang = "en" } = {}) {
//   if (!q?.trim()) return [];
//   const url = `${NOMINATIM_BASE}/search?format=jsonv2&q=${encodeURIComponent(
//     q
//   )}&addressdetails=1&limit=${limit}&accept-language=${encodeURIComponent(lang)}`;
//   const res = await fetch(url, { headers: { "Accept": "application/json" } });
//   if (!res.ok) throw new Error("Search failed");
//   return res.json();
// }

// async function nominatimReverse(lat, lon, { lang = "en" } = {}) {
//   const url = `${NOMINATIM_BASE}/reverse?format=jsonv2&lat=${encodeURIComponent(
//     lat
//   )}&lon=${encodeURIComponent(lon)}&addressdetails=1&accept-language=${encodeURIComponent(lang)}`;
//   const res = await fetch(url, { headers: { "Accept": "application/json" } });
//   if (!res.ok) throw new Error("Reverse failed");
//   return res.json();
// }

// /* ========================= component ========================== */
// export default function ListYourShowForm() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     category: "Music",
//     description: "",
//     venue: {
//       name: "",
//       address: "",
//       city: "",
//       state: "",
//       country: "",
//       pincode: "",
//       latitude: "",
//       longitude: "",
//       capacity: "",
//       logoUrl: "",
//     },
//     date: "",
//     eventEndDate: "",
//     ticketCategories: [
//       {
//         type: "",
//         price: "",
//         currency: "INR",
//         totalSeats: "",
//         availableSeats: "",
//         perks: [""],
//         isTicketAvailable: true,
//       },
//     ],
//     showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
//     imageUrl: "",
//     landsacpImage: [""],
//     layoutImage: "",
//     status: "Upcoming",
//     organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
//     termsAndConditions: [{ point: "" }],
//     ratings: { averageRating: 0, totalReviews: 0 },
//     isVerified: false,
//     isBookingOpen: true,
//     isActived: true,
//     remark: "",
//     tags: [""],
//     sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
//     ageRestriction: "",
//     language: "",
//     duration: "",
//   });

//   const [loading, setLoading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState({});

//   // date min: tomorrow 00:00
//   const now = new Date();
//   const startOfTomorrow = new Date(
//     now.getFullYear(),
//     now.getMonth(),
//     now.getDate() + 1,
//     0,
//     0,
//     0
//   );
//   const minEventDate = toDTLocal(startOfTomorrow);

//   /* --------------------------- setters --------------------------- */
//   const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
//   const onNestedChange = (parent, key, value) =>
//     setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));

//   const onArrayChange = (arrKey, index, key, value) => {
//     const updated = [...form[arrKey]];
//     updated[index][key] = value;
//     setForm((f) => ({ ...f, [arrKey]: updated }));
//   };
//   const addArrayItem = (arrKey, newItem) =>
//     setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
//   const removeArrayItem = (arrKey, index) =>
//     setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

//   /* ------------------------- upload utils ------------------------ */
//   const uploadFileAndGetUrl = async (file, progressKey = "file") => {
//     if (!file) return "";
//     if (!ACCEPTED_IMG.includes(file.type)) {
//       toast.warn("Please upload JPG/PNG/WEBP image.");
//       return "";
//     }
//     if (file.size > MAX_IMG_MB * 1024 * 1024) {
//       toast.warn(`Image must be under ${MAX_IMG_MB} MB.`);
//       return "";
//     }

//     const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//     const fd = new FormData();
//     fd.append("file", file);

//     try {
//       setUploadProgress((p) => ({ ...p, [progressKey]: 1 }));
//       const resp = await post(API.events.fileUploader, fd, {
//         headers: {
//           Authorization: token ? `Bearer ${token}` : undefined,
//           "Content-Type": "multipart/form-data",
//         },
//       });
//       const url =
//         resp?.url ||
//         resp?.resp?.url ||
//         resp?.fileUrl ||
//         resp?.location ||
//         resp?.path ||
//         resp?.secure_url ||
//         "";

//       if (!url) throw new Error("Upload success but no URL returned.");
//       toast.success("Image uploaded ✅");
//       return url;
//     } catch (e) {
//       console.error(e);
//       toast.error("Upload failed ❌");
//       return "";
//     } finally {
//       setUploadProgress((p) => ({ ...p, [progressKey]: 0 }));
//     }
//   };

//   const handlePosterFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "poster");
//     if (url) onChange("imageUrl", url);
//   };

//   const handleLandscapeFile = async (e, index) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, `landscape-${index}`);
//     if (url) {
//       const imgs = [...form.landsacpImage];
//       imgs[index] = url;
//       onChange("landsacpImage", imgs);
//     }
//   };

//   const handleLayoutImageFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "layout"); // progressKey "layout"
//     if (url) onChange("layoutImage", url);
//   };

//   const handleSponsorLogoFile = async (e, index) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
//     if (url) onArrayChange("sponsors", index, "logo", url);
//   };

//   const handleOrganizerLogoFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "organizer");
//     if (url) onNestedChange("organizer", "logoUrl", url);
//   };

//   const handleVenueLogoFile = async (e) => {
//     const file = e.target.files?.[0];
//     if (!file) return;
//     const url = await uploadFileAndGetUrl(file, "venue");
//     if (url) onNestedChange("venue", "logoUrl", url);
//   };

//   /* --------------------------- submit ---------------------------- */
//   const validate = () => {
//     if (!form.name.trim()) return toast.warn("Please enter event name.");
//     if (!form.date) return toast.warn("Please select event date.");
//     if (new Date(form.date) < startOfTomorrow)
//       return toast.warn("Event date must be after today.");
//     if (!form.venue.city.trim()) return toast.warn("Please enter venue city.");
//     if (!form.ticketCategories?.length) return toast.warn("Add at least one ticket category.");
//     const hasAnyAvailable = form.ticketCategories.some((t) => t.isTicketAvailable);
//     if (!hasAnyAvailable) return toast.warn("At least one ticket type must be available.");
//     return true;
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     try {
//       setLoading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const res = await post(API.events.createEvent, form, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: token ? `Bearer ${token}` : undefined,
//         },
//       });
//       console.log("Created event:", res);
//       setTimeout(() => navigate("/admin/events"), 1200);
//       toast.success("Event created successfully ✅");
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to create event ❌");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ----------------------------- UI ----------------------------- */
//   return (
//     <form
//       onSubmit={onSubmit}
//       className="mx-auto max-w-6xl p-6 md:p-8 space-y-6 rounded-2xl border border-amber-100 bg-white/90 backdrop-blur shadow-sm"
//     >
//       {/* Header */}
//       <div className="flex items-center justify-between">
//         <div>
//           <h1 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight">
//             Create Event
//           </h1>
//           <p className="text-sm text-slate-600">
//             Add all details, images, tickets and partners—then publish.
//           </p>
//         </div>
//         <span
//           className={cn(
//             "rounded-full px-3 py-1 text-xs font-semibold",
//             form.isActived ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-700"
//           )}
//         >
//           {form.isActived ? "Active" : "Inactive"}
//         </span>
//       </div>

//       {/* Basic Info */}
//       <Section title="Basic Info" hint="General details and primary schedule.">
//         <div className="grid gap-4 md:grid-cols-2">
//           <Input
//             label="Event Name"
//             value={form.name}
//             onChange={(v) => onChange("name", v)}
//             required
//             placeholder="e.g. Sunburn Arena"
//           />
//           <Select
//             label="Category"
//             value={form.category}
//             onChange={(v) => onChange("category", v)}
//             options={[
//               "Music",
//               "Theatre",
//               "Comedy",
//               "Dance",
//               "Sports",
//               "Exhibition",
//               "Festival",
//               "Conference",
//               "Workshop",
//               "Other",
//             ]}
//           />
//         </div>

//         {/* Rich text editor for description */}
//         <RichText
//           label="Description"
//           value={form.description}
//           onChange={(html) => onChange("description", html)}
//           placeholder="What’s special about this event? Add details, headliners, schedule, FAQs, etc."
//           minHeight={260}
//         />

//         <div className="grid gap-4 md:grid-cols-2">
//           <Input
//             label="Event Date"
//             type="datetime-local"
//             value={form.date}
//             onChange={(v) => {
//               const picked = new Date(v);
//               if (picked < startOfTomorrow) {
//                 toast.warn("Event date must be after today.");
//                 return;
//               }
//               onChange("date", v);
//             }}
//             required
//             min={minEventDate}
//           />
//           <Input
//             label="Event End Date (optional)"
//             type="datetime-local"
//             value={form.eventEndDate}
//             onChange={(v) => onChange("eventEndDate", v)}
//             min={form.date || minEventDate}
//           />
//         </div>
//       </Section>

//       {/* Venue */}
//       <Section title="Venue" hint="Search address or use current location (free via OpenStreetMap).">
//         {/* NEW: Address picker (search + use my location) */}
//         <AddressPicker
//           value={form.venue}
//           onPick={(patch) => {
//             // patch contains address, city, state, country, pincode, latitude, longitude (and maybe name)
//             Object.entries(patch).forEach(([k, v]) => onNestedChange("venue", k, v ?? ""));
//             toast.success("Address filled from map ✅");
//           }}
//         />

//         <div className="grid gap-4 md:grid-cols-2">
//           {["name", "address", "city", "state", "country", "pincode", "latitude", "longitude", "capacity"]
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={capitalize(k)}
//                 value={form.venue[k]}
//                 onChange={(v) => onNestedChange("venue", k, v)}
//                 type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
//               />
//             ))}
//         </div>

//         <Uploader
//           label="Venue Logo"
//           progress={uploadProgress["venue"] > 0}
//           onFile={handleVenueLogoFile}
//           previewUrl={form.venue.logoUrl}
//           onClear={() => onNestedChange("venue", "logoUrl", "")}
//         />
//       </Section>

//       {/* Tickets */}
//       <Section title="Ticket Categories" hint="Types, prices and perks.">
//         {form.ticketCategories.map((t, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className="grid gap-4 md:grid-cols-2">
//               <Input
//                 label="Type"
//                 value={t.type}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "type", v)}
//                 placeholder="e.g. VIP / Gold / GA"
//               />
//               <Input
//                 label="Price (₹)"
//                 type="number"
//                 value={t.price}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "price", v)}
//                 disabled={!t.isTicketAvailable}
//               />
//               <Input
//                 label="Currency"
//                 value={t.currency}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "currency", v)}
//                 disabled={!t.isTicketAvailable}
//               />
//               <Input
//                 label="Total Seats"
//                 type="number"
//                 value={t.totalSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "totalSeats", v)}
//                 disabled={!t.isTicketAvailable}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={t.availableSeats}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "availableSeats", v)}
//                 disabled={!t.isTicketAvailable}
//               />
//             </div>

//             <div className="mt-3 grid sm:grid-cols-2 gap-3">
//               <Toggle
//                 label="Tickets Available"
//                 checked={!!t.isTicketAvailable}
//                 onChange={(v) => onArrayChange("ticketCategories", i, "isTicketAvailable", v)}
//               />
//             </div>

//             <div className="mt-4">
//               <Label>Perks</Label>
//               {t.perks.map((perk, j) => (
//                 <div key={j} className="flex items-center gap-2 mb-2">
//                   <input
//                     className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//                     value={perk}
//                     onChange={(e) => {
//                       const updated = [...t.perks];
//                       updated[j] = e.target.value;
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                     placeholder="Add a perk…"
//                     disabled={!t.isTicketAvailable}
//                   />
//                   <IconButton
//                     label="Remove Perk"
//                     onClick={() => {
//                       const updated = t.perks.filter((_, idx) => idx !== j);
//                       onArrayChange("ticketCategories", i, "perks", updated);
//                     }}
//                   >
//                     <FaTrash />
//                   </IconButton>
//                 </div>
//               ))}
//               <GhostButton
//                 onClick={() =>
//                   onArrayChange("ticketCategories", i, "perks", [...t.perks, ""])
//                 }
//               >
//                 <FaPlus /> Add Perk
//               </GhostButton>
//             </div>

//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("ticketCategories", i)}>
//                 <FaTrash /> Remove Ticket
//               </DangerButton>
//             </div>
//           </div>
//         ))}

//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("ticketCategories", {
//               type: "",
//               price: "",
//               currency: "INR",
//               totalSeats: "",
//               availableSeats: "",
//               perks: [""],
//               isTicketAvailable: true,
//             })
//           }
//         >
//           <FaPlus /> Add Ticket
//         </PrimaryGhost>
//       </Section>

//       {/* Showtimes */}
//       <Section title="Showtimes" hint="Multiple slots for multi-show events.">
//         {form.showtimes.map((s, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className="grid gap-4 md:grid-cols-2">
//               <Input
//                 label="Start Time"
//                 type="datetime-local"
//                 value={s.startTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "startTime", v)}
//               />
//               <Input
//                 label="End Time"
//                 type="datetime-local"
//                 value={s.endTime}
//                 onChange={(v) => onArrayChange("showtimes", i, "endTime", v)}
//               />
//               <Input
//                 label="Available Seats"
//                 type="number"
//                 value={s.availableSeats}
//                 onChange={(v) => onArrayChange("showtimes", i, "availableSeats", v)}
//               />
//               <Input
//                 label="Ticket Price (₹)"
//                 type="number"
//                 value={s.ticketPrice}
//                 onChange={(v) => onArrayChange("showtimes", i, "ticketPrice", v)}
//               />
//             </div>
//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("showtimes", i)}>
//                 <FaTrash /> Remove Showtime
//               </DangerButton>
//             </div>
//           </div>
//         ))}

//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("showtimes", {
//               startTime: "",
//               endTime: "",
//               availableSeats: "",
//               ticketPrice: "",
//             })
//           }
//         >
//           <FaPlus /> Add Showtime
//         </PrimaryGhost>
//       </Section>

//       {/* Images */}
//       <Section title="Images" hint="Poster and landscape gallery.">
//         <Uploader
//           label="Poster Image"
//           progress={uploadProgress["poster"] > 0}
//           onFile={handlePosterFile}
//           previewUrl={form.imageUrl}
//           onClear={() => onChange("imageUrl", "")}
//         />

//         <div className="mt-4 space-y-2">
//           <Label>Landscape Images</Label>
//           {form.landsacpImage.map((img, i) => (
//             <div key={i} className="flex flex-col md:flex-row items-start md:items-center gap-3">
//               <input
//                 className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//                 placeholder="Paste image URL (optional)"
//                 value={img}
//                 onChange={(e) => {
//                   const imgs = [...form.landsacpImage];
//                   imgs[i] = e.target.value;
//                   onChange("landsacpImage", imgs);
//                 }}
//               />
//               <div>
//                 <input
//                   id={`landscape-upload-${i}`}
//                   type="file"
//                   accept={ACCEPTED_IMG.join(",")}
//                   className="hidden"
//                   onChange={(e) => handleLandscapeFile(e, i)}
//                 />
//                 <label
//                   htmlFor={`landscape-upload-${i}`}
//                   className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
//                 >
//                   <FaUpload /> Upload
//                 </label>
//               </div>
//               <IconButton
//                 label="Remove Image"
//                 onClick={() => removeArrayItem("landsacpImage", i)}
//               >
//                 <FaTrash />
//               </IconButton>

//               {img ? (
//                 <img src={img} alt={`Landscape ${i + 1}`} className="h-16 w-24 object-cover rounded border" />
//               ) : (
//                 <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
//                   <FaImage />
//                 </div>
//               )}
//             </div>
//           ))}
//           <PrimaryGhost onClick={() => onChange("landsacpImage", [...form.landsacpImage, ""])}>
//             <FaPlus /> Add Landscape Image
//           </PrimaryGhost>
//         </div>
//       </Section>

//       <Section title="Layout / Seating Plan" hint="Upload a hall/ground layout image (optional).">
//         <Uploader
//           label="Layout Image"
//           progress={uploadProgress["layout"] > 0}
//           onFile={handleLayoutImageFile}
//           previewUrl={form.layoutImage}
//           onClear={() => onChange("layoutImage", "")}
//         />

//         {/* (Optional) URL input as well */}
//         <div className="mt-3">
//           <Label>Or paste image URL</Label>
//           <input
//             className="border p-2 w-full rounded-xl focus:ring-2 focus:ring-amber-300"
//             placeholder="https://…"
//             value={form.layoutImage}
//             onChange={(e) => onChange("layoutImage", e.target.value)}
//           />
//         </div>
//       </Section>

//       {/* Organizer */}
//       <Section title="Organizer" hint="Organizer details & branding.">
//         <div className="grid gap-4 md:grid-cols-2">
//           {Object.keys(form.organizer)
//             .filter((k) => k !== "logoUrl")
//             .map((k) => (
//               <Input
//                 key={k}
//                 label={capitalize(k)}
//                 value={form.organizer[k]}
//                 onChange={(v) => onNestedChange("organizer", k, v)}
//               />
//             ))}
//         </div>
//         <Uploader
//           label="Organizer Logo"
//           progress={uploadProgress["organizer"] > 0}
//           onFile={handleOrganizerLogoFile}
//           previewUrl={form.organizer.logoUrl}
//           onClear={() => onNestedChange("organizer", "logoUrl", "")}
//         />
//       </Section>

//       {/* Sponsors */}
//       <Section title="Sponsors" hint="Add partner logos and types.">
//         {form.sponsors.map((s, i) => (
//           <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
//             <div className="grid gap-4 md:grid-cols-2">
//               <Input
//                 label="Name"
//                 value={s.name}
//                 onChange={(v) => onArrayChange("sponsors", i, "name", v)}
//               />
//               <Select
//                 label="Type"
//                 value={s.type}
//                 onChange={(v) => onArrayChange("sponsors", i, "type", v)}
//                 options={[
//                   "Title Sponsor",
//                   "Presenting Sponsor",
//                   "Powered By Sponsor",
//                   "Associate Sponsor",
//                   "Official Partner",
//                   "Official Beverage Partner",
//                   "Official Food Partner",
//                   "Official Travel Partner",
//                   "Official Airline Partner",
//                   "Official Transport Partner",
//                   "Official Hotel Partner",
//                   "Official Hospitality Partner",
//                   "Official Bank Partner",
//                   "Official Insurance Partner",
//                   "Official Payment Partner",
//                   "Official Apparel Partner",
//                   "Official Footwear Partner",
//                   "Official Merchandise Partner",
//                   "Official Electronics Partner",
//                   "Official Technology Partner",
//                   "Official Streaming Partner",
//                   "Official Ticketing Partner",
//                   "Official Education Partner",
//                   "Official Telecom Partner",
//                   "Venue Partner",
//                   "Logistics Partner",
//                   "Stage & Equipment Partner",
//                   "Printing Partner",
//                   "Security Partner",
//                   "Decoration Partner",
//                   "Photography Partner",
//                   "Medical Partner",
//                   "Gifts Partner",
//                   "Print Media Partner",
//                   "TV Media Partner",
//                   "Radio Partner",
//                   "Digital Media Partner",
//                   "Outdoor Media Partner",
//                   "Social Media Partner",
//                   "Accommodation Partner",
//                   "Catering Partner",
//                   "Food & Beverage Partner",
//                   "Lounge Partner",
//                   "App Partner",
//                   "WiFi Partner",
//                   "Virtual Event Partner",
//                   "AR/VR Partner",
//                   "Gaming Partner",
//                   "NGO Partner",
//                   "Environmental Partner",
//                   "Government Partner",
//                   "Cultural Partner",
//                 ]}
//               />
//             </div>
//             <Textarea
//               label="Description"
//               value={s.description}
//               onChange={(v) => onArrayChange("sponsors", i, "description", v)}
//               rows={3}
//             />
//             <Uploader
//               label="Logo"
//               progress={uploadProgress[`sponsor-${i}`] > 0}
//               onFile={(e) => handleSponsorLogoFile(e, i)}
//               previewUrl={s.logo}
//               onClear={() => onArrayChange("sponsors", i, "logo", "")}
//               inputId={`sponsor-logo-upload-${i}`}
//             />
//             <div className="mt-3">
//               <DangerButton onClick={() => removeArrayItem("sponsors", i)}>
//                 <FaTrash /> Remove Sponsor
//               </DangerButton>
//             </div>
//           </div>
//         ))}
//         <PrimaryGhost
//           onClick={() =>
//             addArrayItem("sponsors", {
//               name: "",
//               logo: "",
//               description: "",
//               type: "Title Sponsor",
//             })
//           }
//         >
//           <FaPlus /> Add Sponsor
//         </PrimaryGhost>
//       </Section>

//       {/* Terms & Conditions */}
//       <Section title="Terms & Conditions" hint="Displayed on the event page.">
//         {form.termsAndConditions.map((t, i) => (
//           <div key={i} className="flex items-center gap-2 mb-2">
//             <input
//               className="border p-2 w-full rounded-md focus:ring-2 focus:ring-amber-300"
//               placeholder="Write a point…"
//               value={t.point}
//               onChange={(e) => onArrayChange("termsAndConditions", i, "point", e.target.value)}
//             />
//             <IconButton label="Remove" onClick={() => removeArrayItem("termsAndConditions", i)}>
//               <FaTrash />
//             </IconButton>
//           </div>
//         ))}
//         <PrimaryGhost onClick={() => addArrayItem("termsAndConditions", { point: "" })}>
//           <FaPlus /> Add Point
//         </PrimaryGhost>
//       </Section>

//       {/* Other Details */}
//       <Section title="Other Details">
//         <div className="grid gap-4 md:grid-cols-2">
//           <Select
//             label="Status"
//             value={form.status}
//             onChange={(v) => onChange("status", v)}
//             options={["Upcoming", "Live"]}
//           />
//           <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
//           <Input
//             label="Age Restriction"
//             type="number"
//             value={form.ageRestriction}
//             onChange={(v) => onChange("ageRestriction", v)}
//           />
//           <Input label="Language" value={form.language} onChange={(v) => onChange("language", v)} />
//           <Input
//             label="Duration (minutes)"
//             type="number"
//             value={form.duration}
//             onChange={(v) => onChange("duration", v)}
//           />
//         </div>

//         {/* Toggles */}
//         <div className="mt-3 grid gap-3 sm:grid-cols-3">
//           {/* <Toggle
//             label="Premium"
//             checked={form.isVerified}
//             onChange={(v) => onChange("isVerified", v)}
//           /> */}
//           <Toggle
//             label="Booking Open"
//             checked={form.isBookingOpen}
//             onChange={(v) => onChange("isBookingOpen", v)}
//           />
//           <Toggle
//             label="Active"
//             checked={form.isActived}
//             onChange={(v) => onChange("isActived", v)}
//           />
//         </div>
//       </Section>

//       {/* Sticky footer actions */}
//       <div className="sticky bottom-3 z-10">
//         <div className="rounded-2xl border bg-white/90 backdrop-blur p-3 shadow-md flex items-center gap-3">
//           <button
//             type="submit"
//             className={cn(
//               "rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 px-6 py-2.5 text-sm font-semibold text-slate-900 hover:from-yellow-500 hover:to-yellow-600 transition-all",
//               loading && "opacity-60 cursor-wait"
//             )}
//             disabled={loading}
//           >
//             {loading ? (
//               <span className="inline-flex items-center gap-2">
//                 <FaSpinner className="animate-spin" /> Submitting…
//               </span>
//             ) : (
//               "Create Event"
//             )}
//           </button>

//           {loading ? (
//             <span className="text-sm text-slate-600 flex items-center gap-2">
//               <FaSpinner className="animate-spin" /> Please wait
//             </span>
//           ) : form.name && form.imageUrl ? (
//             <span className="text-sm text-emerald-600 flex items-center gap-2">
//               <FaCheckCircle /> Ready to publish
//             </span>
//           ) : (
//             <span className="text-sm text-slate-500 flex items-center gap-2">
//               <FaTimesCircle /> Add name & poster to proceed
//             </span>
//           )}
//         </div>
//       </div>
//     </form>
//   );
// }

// /* ========================= Address Picker ========================= */
// function AddressPicker({ value, onPick }) {
//   const [q, setQ] = useState(value?.address || "");
//   const [loading, setLoading] = useState(false);
//   const [results, setResults] = useState([]);
//   const [open, setOpen] = useState(false);
//   const debounced = useDebouncedValue(q, 300);
//   const boxRef = useRef(null);

//   useEffect(() => {
//     setQ(value?.address || "");
//   }, [value?.address]);

//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       if (!debounced || debounced.trim().length < 3) {
//         setResults([]);
//         return;
//       }
//       setLoading(true);
//       try {
//         const arr = await nominatimSearch(debounced, { limit: 6 });
//         if (!alive) return;
//         setResults(arr || []);
//         setOpen(true);
//       } catch (e) {
//         console.error(e);
//       } finally {
//         if (alive) setLoading(false);
//       }
//     })();
//     return () => {
//       alive = false;
//     };
//   }, [debounced]);

//   // click outside to close
//   useEffect(() => {
//     const onClick = (e) => {
//       if (!boxRef.current) return;
//       if (!boxRef.current.contains(e.target)) setOpen(false);
//     };
//     document.addEventListener("mousedown", onClick);
//     return () => document.removeEventListener("mousedown", onClick);
//   }, []);

//   const handlePick = (osm) => {
//     const patch = normalizeAddress(osm);
//     onPick?.(patch);
//     setQ(patch.address || "");
//     setOpen(false);
//   };

//   const useMyLocation = () => {
//     if (!navigator.geolocation) {
//       toast.warn("Geolocation not supported in this browser.");
//       return;
//     }
//     setLoading(true);
//     navigator.geolocation.getCurrentPosition(
//       async (pos) => {
//         try {
//           const { latitude, longitude } = pos.coords;
//           const osm = await nominatimReverse(latitude, longitude);
//           const patch = normalizeAddress(osm);
//           onPick?.(patch);
//           setQ(patch.address || "");
//           toast.success("Fetched address from your location 📍");
//         } catch (e) {
//           console.error(e);
//           toast.error("Failed to reverse geocode location.");
//         } finally {
//           setLoading(false);
//           setOpen(false);
//         }
//       },
//       (err) => {
//         console.error(err);
//         setLoading(false);
//         toast.error("Could not access your location.");
//       },
//       { enableHighAccuracy: true, timeout: 10000 }
//     );
//   };

//   return (
//     <div className="relative" ref={boxRef}>
//       <Label>Find Address</Label>
//       <div className="mt-1 flex gap-2">
//         <div className="relative flex-1">
//           <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
//           <input
//             className="pl-9 pr-3 py-2.5 w-full rounded-xl border focus:ring-2 focus:ring-amber-300"
//             placeholder="Search place, venue, street…"
//             value={q}
//             onChange={(e) => setQ(e.target.value)}
//             onFocus={() => results.length && setOpen(true)}
//           />
//           {loading && (
//             <FaSpinner className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-slate-400" />
//           )}
//         </div>

//         <button
//           type="button"
//           onClick={useMyLocation}
//           className="inline-flex items-center gap-2 rounded-xl border px-3 py-2.5 text-sm font-semibold hover:bg-slate-50"
//           title="Use my current location"
//         >
//           <FaCrosshairs /> Use my location
//         </button>
//       </div>

//       {open && results.length > 0 && (
//         <div className="absolute z-20 mt-1 w-full rounded-xl border bg-white shadow-lg max-h-64 overflow-auto">
//           {results.map((r) => (
//             <button
//               type="button"
//               key={`${r.place_id}-${r.lat}-${r.lon}`}
//               onClick={() => handlePick(r)}
//               className="w-full text-left px-3 py-2 hover:bg-amber-50"
//             >
//               <div className="flex items-start gap-2">
//                 <FaMapMarkerAlt className="mt-1 text-amber-600" />
//                 <div>
//                   <div className="font-semibold text-slate-800">
//                     {r.display_name?.split(",")?.[0] || "Place"}
//                   </div>
//                   <div className="text-xs text-slate-600 truncate">{r.display_name}</div>
//                 </div>
//               </div>
//             </button>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ========================= small bits ========================= */
// function Section({ title, hint, children }) {
//   return (
//     <div className="rounded-2xl border border-amber-100/70 bg-white/70 p-5 shadow-sm">
//       <div className="mb-3">
//         <h2 className="text-lg font-bold text-slate-900">{title}</h2>
//         {hint && <p className="text-xs text-slate-500">{hint}</p>}
//       </div>
//       <div className="space-y-4">{children}</div>
//     </div>
//   );
// }

// function Label({ children }) {
//   return <label className="block font-semibold text-slate-700">{children}</label>;
// }

// function Input({ label, value, onChange, type = "text", required = false, placeholder, min, disabled }) {
//   return (
//     <div>
//       <Label>
//         {label}
//         {required && <span className="text-rose-500"> *</span>}
//       </Label>
//       <input
//         type={type}
//         className={`mt-1 border w-full rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-300 disabled:opacity-60`}
//         value={value}
//         min={min}
//         onChange={(e) => onChange(e.target.value)}
//         required={required}
//         placeholder={placeholder}
//         aria-label={label}
//         disabled={disabled}
//       />
//     </div>
//   );
// }

// function Textarea({ label, value, onChange, rows = 4, placeholder }) {
//   return (
//     <div>
//       <Label>{label}</Label>
//       <textarea
//         className="mt-1 border w-full rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-300"
//         value={value}
//         onChange={(e) => onChange(e.target.value)}
//         rows={rows}
//         placeholder={placeholder}
//         aria-label={label}
//       />
//     </div>
//   );
// }

// function Select({ label, value, onChange, options = [], disabled }) {
//   return (
//     <div>
//       <Label>{label}</Label>
//       <div className="relative mt-1">
//         <select
//           className="w-full appearance-none rounded-xl border px-3 py-2.5 pr-9 focus:ring-2 focus:ring-amber-300 disabled:opacity-60"
//           value={value}
//           onChange={(e) => onChange(e.target.value)}
//           aria-label={label}
//           disabled={disabled}
//         >
//           {options.map((opt) => (
//             <option key={opt} value={opt}>
//               {opt}
//             </option>
//           ))}
//         </select>
//         <svg
//           className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
//           width="16"
//           height="16"
//           viewBox="0 0 24 24"
//           fill="none"
//           stroke="currentColor"
//           strokeWidth="1.8"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//         >
//           <path d="M6 9l6 6 6-6" />
//         </svg>
//       </div>
//     </div>
//   );
// }

// function Uploader({ label, progress, onFile, previewUrl, onClear, inputId }) {
//   const id = inputId || `uploader-${label.replace(/\s+/g, "-").toLowerCase()}`;
//   return (
//     <div>
//       <Label>{label}</Label>
//       <div className="mt-2 flex flex-col md:flex-row items-start md:items-center gap-3">
//         <input id={id} type="file" accept={ACCEPTED_IMG.join(",")} className="hidden" onChange={onFile} />
//         <label
//           htmlFor={id}
//           className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
//         >
//           {progress ? <FaSpinner className="animate-spin" /> : <FaUpload />}
//           {progress ? "Uploading…" : "Upload"}
//         </label>

//         {previewUrl ? (
//           <>
//             <img src={previewUrl} alt="preview" className="h-16 w-24 object-cover rounded border" />
//             <IconButton label="Remove" onClick={onClear}>
//               <FaTrash />
//             </IconButton>
//           </>
//         ) : (
//           <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
//             <FaImage />
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// function Toggle({ label, checked, onChange }) {
//   return (
//     <div className="flex items-center justify-between rounded-xl border px-4 py-3 bg-white">
//       <div className="text-sm font-semibold text-slate-800">{label}</div>
//       <label className="relative inline-flex items-center cursor-pointer">
//         <input
//           type="checkbox"
//           checked={checked}
//           onChange={(e) => onChange(e.target.checked)}
//           className="sr-only peer"
//         />
//         <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//           <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//         </div>
//       </label>
//     </div>
//   );
// }

// function IconButton({ children, onClick, label }) {
//   return (
//     <button
//       type="button"
//       title={label}
//       aria-label={label}
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50"
//     >
//       {children}
//     </button>
//   );
// }

// function DangerButton({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border border-rose-300 text-rose-600 px-3 py-2 text-sm font-semibold hover:bg-rose-50"
//     >
//       {children}
//     </button>
//   );
// }

// function PrimaryGhost({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-amber-50"
//     >
//       {children}
//     </button>
//   );
// }

// function GhostButton({ children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className="inline-flex items-center gap-2 text-amber-700 hover:text-amber-900"
//     >
//       {children}
//     </button>
//   );
// }

// function capitalize(s = "") {
//   return s.charAt(0).toUpperCase() + s.slice(1);
// }


import React, { useEffect, useRef, useState } from "react";
import { API } from "../config/api";
import { post, get, put } from "../lib/http";
import { FaArrowLeft } from "react-icons/fa";

import {
    FaPlus,
    FaTrash,
    FaSpinner,
    FaCheckCircle,
    FaTimesCircle,
    FaUpload,
    FaImage,
    FaMapMarkerAlt,
    FaCrosshairs,
    FaSearch,
    FaPencilAlt,
} from "react-icons/fa";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import RichText from "../admin/pages/events/RichText.jsx";
import { isOrganizerApprovalError } from "../organizer/organizerApplication.js";
import CategorySubcategoryFields from "./CategorySubcategoryFields.jsx";
import {
    AGE_GROUP_OPTIONS,
    CREATE_EVENT_STEPS,
    PERFORMER_ROLES,
} from "./eventCategories.js";
import {
    TNC_TEMPLATES,
    htmlToPoints,
    pointsToHtml,
    templateToHtml,
    templateToPoints,
} from "./additionalInfoDefaults.js";
import {
    BANNER_MAX_MB,
    GALLERY_DESC_MAX,
    GALLERY_FOLDER_OPTIONS,
    emptyGalleryFolders,
    emptyLandscapeSlots,
    ensureLandscapeSlots,
} from "./posterStepDefaults.js";
import {
    emptyScheduleDay,
    formatDayLabel,
    isScheduleComplete,
    listScheduleDates,
    minDateISO,
    scheduleSummaryLines,
    syncScheduleToLegacy,
    ticketDisplayName,
    uniqueTicketType,
} from "./scheduleHelpers.js";
import { FaCheck, FaExclamationTriangle } from "react-icons/fa";

/* --------------------------- helpers --------------------------- */
const toDTLocal = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(
        d.getHours()
    )}:${pad(d.getMinutes())}`;
};
const cn = (...a) => a.filter(Boolean).join(" ");
const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
const MAX_IMG_MB = 5;

// Small debounce hook for typeahead
function useDebouncedValue(value, ms = 300) {
    const [v, setV] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setV(value), ms);
        return () => clearTimeout(t);
    }, [value, ms]);
    return v;
}

// Nominatim helpers (free; please keep requests light to respect usage policy)
const NOMINATIM_BASE = "https://nominatim.openstreetmap.org";

// normalize nominatim -> our venue shape
function normalizeAddress(osm) {
    const a = osm?.address || {};
    const city = a.city || a.town || a.village || a.hamlet || "";
    const state = a.state || a.region || "";
    const country = a.country || "";
    const pincode = a.postcode || "";
    const name = a.neighbourhood || a.suburb || a.quarter || a.road || a.residential || "";
    const address = osm?.display_name || "";
    return {
        name,
        address,
        city,
        state,
        country,
        pincode,
        latitude: String(osm?.lat || ""),
        longitude: String(osm?.lon || ""),
    };
}

async function nominatimSearch(q, { limit = 5, lang = "en" } = {}) {
    if (!q?.trim()) return [];
    const url = `${NOMINATIM_BASE}/search?format=jsonv2&q=${encodeURIComponent(
        q
    )}&addressdetails=1&limit=${limit}&accept-language=${encodeURIComponent(lang)}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Search failed");
    return res.json();
}

async function nominatimReverse(lat, lon, { lang = "en" } = {}) {
    const url = `${NOMINATIM_BASE}/reverse?format=jsonv2&lat=${encodeURIComponent(
        lat
    )}&lon=${encodeURIComponent(lon)}&addressdetails=1&accept-language=${encodeURIComponent(lang)}`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("Reverse failed");
    return res.json();
}

function formatDateTimeForInput(value) {
    if (!value) return "";
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    // Wall-clock UTC face for datetime-local inputs
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(
        d.getUTCMinutes()
    )}`;
}

function toDateOnly(value) {
    if (!value) return "";
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    const pad = (n) => String(n).padStart(2, "0");
    // Wall-clock UTC face (showtimes store face time as Z)
    return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}`;
}

function hydrateScheduleDays(ev) {
    if (Array.isArray(ev?.scheduleDays) && ev.scheduleDays.length) {
        return ev.scheduleDays.map((d) => ({
            active: d.active !== false,
            date: d.date || "",
            times: Array.isArray(d.times) && d.times.length ? [...d.times] : [""],
            recurring: !!d.recurring,
        }));
    }
    const byDate = new Map();
    for (const s of ev?.showtimes || []) {
        if (!s?.startTime) continue;
        const d = new Date(s.startTime);
        if (Number.isNaN(d.getTime())) continue;
        const date = toDateOnly(d);
        const time = `${String(d.getUTCHours()).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")}`;
        if (!byDate.has(date)) byDate.set(date, []);
        byDate.get(date).push(time);
    }
    if (byDate.size) {
        return [...byDate.entries()].map(([date, times]) => ({
            active: true,
            date,
            times,
            recurring: false,
        }));
    }
    if (ev?.date) {
        return [{ active: true, date: toDateOnly(ev.date), times: [""], recurring: false }];
    }
    return [emptyScheduleDay()];
}

function hydrateGallery(ev) {
    const folders = emptyGalleryFolders();
    const incoming = Array.isArray(ev?.gallery) ? ev.gallery : [];
    if (!incoming.length) return folders;
    return folders.map((slot) => {
        const match = incoming.find((g) => g.folder === slot.folder) || {};
        return {
            folder: slot.folder,
            images: Array.isArray(match.images) ? match.images.filter(Boolean) : [],
            videos: Array.isArray(match.videos) ? match.videos.filter(Boolean) : [],
        };
    });
}

/* ========================= component ========================== */
export default function ListYourShowForm({
    successRedirect = "/listyourshow/manage",
    exitTo = null,
    eventId = null,
    adminPublishControls = false,
} = {}) {
    const navigate = useNavigate();
    const isEditMode = Boolean(eventId);
    let role = "";
    try {
        role = String(JSON.parse(localStorage.getItem("bb_user") || "null")?.role || "").toLowerCase();
    } catch {
        role = "";
    }
    const isSuperadmin = role === "superadmin";
    const showAdminPublish = Boolean(adminPublishControls && isSuperadmin);
    const [form, setForm] = useState({
        name: "",
        category: "",
        subcategory: "",
        subcategories: [],
        genres: [],
        languages: [],
        usps: [],
        performers: [],
        description: "",
        venue: {
            name: "",
            address: "",
            city: "",
            state: "",
            country: "",
            pincode: "",
            latitude: "",
            longitude: "",
            capacity: "",
            logoUrl: "",
        },
        date: "",
        eventEndDate: "",
        scheduleDays: [emptyScheduleDay()],
        ticketCategories: [],
        showtimes: [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
        imageUrl: "",
        landsacpImage: emptyLandscapeSlots(),
        layoutImage: "",
        promoVideoUrl: "",
        galleryDescription: "",
        gallery: emptyGalleryFolders(),
        status: "Upcoming",
        organizer: { name: "", contactEmail: "", contactPhone: "", website: "", logoUrl: "" },
        termsAndConditions: templateToPoints("default"),
        termsHtml: templateToHtml("default"),
        tncTemplate: "default",
        faqs: [],
        youShouldKnow: [],
        ticketSalesNotification: false,
        ratings: { averageRating: 0, totalReviews: 0 },
        isVerified: false,
        isBookingOpen: isSuperadmin,
        isActived: isSuperadmin,
        remark: "",
        tags: [""],
        sponsors: [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
        ageRestriction: "0",
        language: "",
        duration: "",
        gstRatePercent: "",
        conveniencesFeeType: "convenienceFeeFlat",
        convenienceFeeFlat: "",
        convenienceFeePercent: "",
    });

    const [stepIndex, setStepIndex] = useState(0);
    const [stepErrors, setStepErrors] = useState(false);
    const [performerQuery, setPerformerQuery] = useState("");
    const [activeGalleryFolder, setActiveGalleryFolder] = useState(GALLERY_FOLDER_OPTIONS[0]);
    const [galleryVideoDraft, setGalleryVideoDraft] = useState("");
    const [venueEditing, setVenueEditing] = useState(true);
    const [editingTicketIndex, setEditingTicketIndex] = useState(null);
    const [ticketDateTab, setTicketDateTab] = useState("");
    const [loading, setLoading] = useState(false);
    const [bootLoading, setBootLoading] = useState(isEditMode);
    const [uploadProgress, setUploadProgress] = useState({});

    // date min: tomorrow 00:00
    const now = new Date();
    const startOfTomorrow = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
        0, 0, 0
    );
    const minEventDate = toDTLocal(startOfTomorrow);

    /* --------------------------- load existing event (edit) --------------------------- */
    useEffect(() => {
        if (!eventId) return undefined;
        let alive = true;
        (async () => {
            try {
                setBootLoading(true);
                const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
                const res = await get(`${API.events.getSinglEvent}/${eventId}`, {
                    headers: {
                        Authorization: token ? `Bearer ${token}` : undefined,
                        "Content-Type": "application/json",
                    },
                });
                if (!alive || !res?.event) return;
                const ev = res.event;
                const terms =
                    Array.isArray(ev.termsAndConditions) && ev.termsAndConditions.length
                        ? ev.termsAndConditions
                        : templateToPoints("default");
                setForm((prev) => ({
                    ...prev,
                    name: ev.name || "",
                    category: ev.category || "",
                    subcategory: ev.subcategory || "",
                    subcategories:
                        ev.subcategories?.length
                            ? ev.subcategories
                            : ev.subcategory
                                ? [ev.subcategory]
                                : [],
                    genres: ev.genres || [],
                    languages:
                        ev.languages?.length
                            ? ev.languages
                            : ev.language
                                ? String(ev.language)
                                    .split(",")
                                    .map((s) => s.trim())
                                    .filter(Boolean)
                                : [],
                    usps: ev.usps || [],
                    performers: Array.isArray(ev.performers) ? ev.performers : [],
                    description: ev.description || "",
                    venue: {
                        name: ev.venue?.name || "",
                        address: ev.venue?.address || "",
                        city: ev.venue?.city || "",
                        state: ev.venue?.state || "",
                        country: ev.venue?.country || "",
                        pincode: ev.venue?.pincode || "",
                        latitude: ev.venue?.latitude ?? ev.venue?.lat ?? "",
                        longitude: ev.venue?.longitude ?? ev.venue?.lon ?? "",
                        capacity: ev.venue?.capacity || "",
                        logoUrl: ev.venue?.logoUrl || "",
                    },
                    date: formatDateTimeForInput(ev.date) || "",
                    eventEndDate: toDateOnly(ev.endDate) || "",
                    scheduleDays: hydrateScheduleDays(ev),
                    ticketCategories:
                        Array.isArray(ev.ticketCategories) && ev.ticketCategories.length
                            ? ev.ticketCategories.map((t) => ({
                                ...t,
                                type: ticketDisplayName(t.type) || t.type || "",
                                date: String(t.date || "").trim(),
                                isTicketAvailable: t?.isTicketAvailable ?? true,
                                perks: Array.isArray(t?.perks) ? t.perks : [],
                            }))
                            : [],
                    showtimes:
                        Array.isArray(ev.showtimes) && ev.showtimes.length
                            ? ev.showtimes.map((s) => ({
                                startTime: formatDateTimeForInput(s.startTime),
                                endTime: formatDateTimeForInput(s.endTime),
                                availableSeats: s.availableSeats || "",
                                ticketPrice: s.ticketPrice || "",
                            }))
                            : [{ startTime: "", endTime: "", availableSeats: "", ticketPrice: "" }],
                    imageUrl: ev.imageUrl || "",
                    landsacpImage: ensureLandscapeSlots(
                        ev.landsacpImage?.length ? ev.landsacpImage : emptyLandscapeSlots()
                    ),
                    layoutImage: ev.layoutImage || "",
                    promoVideoUrl: ev.promoVideoUrl || "",
                    galleryDescription: ev.galleryDescription || "",
                    gallery: hydrateGallery(ev),
                    status: ev.status || "Upcoming",
                    organizer: {
                        name: ev.organizer?.name || "",
                        contactEmail: ev.organizer?.contactEmail || "",
                        contactPhone: ev.organizer?.contactPhone || "",
                        website: ev.organizer?.website || "",
                        logoUrl: ev.organizer?.logoUrl || "",
                    },
                    termsAndConditions: terms,
                    termsHtml: pointsToHtml(terms),
                    tncTemplate: "default",
                    faqs: Array.isArray(ev.faqs) ? ev.faqs : [],
                    youShouldKnow: Array.isArray(ev.youShouldKnow) ? ev.youShouldKnow : [],
                    ticketSalesNotification: !!ev.ticketSalesNotification,
                    ratings: {
                        averageRating: ev.ratings?.averageRating || 0,
                        totalReviews: ev.ratings?.totalReviews || 0,
                    },
                    isVerified: !!ev.isVerified,
                    isBookingOpen: ev.isBookingOpen ?? true,
                    isActived: ev.isActived ?? true,
                    remark: ev.remark || "",
                    tags: ev.tags?.length ? ev.tags : [""],
                    sponsors:
                        ev.sponsors?.length
                            ? ev.sponsors
                            : [{ name: "", logo: "", description: "", type: "Title Sponsor" }],
                    ageRestriction: String(ev.ageRestriction ?? "0"),
                    language: ev.language || "",
                    duration: ev.duration ?? "",
                    gstRatePercent:
                        ev.gstRate != null && ev.gstRate !== ""
                            ? String(Number(ev.gstRate) * 100)
                            : "",
                    conveniencesFeeType: ev.conveniencesFeeType || "convenienceFeeFlat",
                    convenienceFeeFlat:
                        ev.convenienceFeeFlat != null && ev.convenienceFeeFlat !== ""
                            ? String(ev.convenienceFeeFlat)
                            : "",
                    convenienceFeePercent: (() => {
                        if (ev.convenienceFeePercent == null || ev.convenienceFeePercent === "") return "";
                        const n = Number(ev.convenienceFeePercent);
                        if (!Number.isFinite(n)) return "";
                        // DB stores fraction (0.08); UI shows percent (8). Legacy bad values (>1) treated as percent.
                        return String(n > 0 && n <= 1 ? n * 100 : n);
                    })(),
                }));
                setVenueEditing(false);
                const firstTicketDate = (ev.ticketCategories || [])
                    .map((t) => String(t?.date || "").trim())
                    .filter(Boolean)
                    .sort()[0];
                if (firstTicketDate) setTicketDateTab(firstTicketDate);
            } catch (err) {
                console.error(err);
                toast.error(err?.message || "Failed to load event");
            } finally {
                if (alive) setBootLoading(false);
            }
        })();
        return () => {
            alive = false;
        };
    }, [eventId]);

    /* --------------------------- setters --------------------------- */
    const onChange = (key, value) => setForm((f) => ({ ...f, [key]: value }));
    const onNestedChange = (parent, key, value) =>
        setForm((f) => ({ ...f, [parent]: { ...f[parent], [key]: value } }));

    const onArrayChange = (arrKey, index, key, value) => {
        const updated = [...form[arrKey]];
        updated[index][key] = value;
        setForm((f) => ({ ...f, [arrKey]: updated }));
    };
    const addArrayItem = (arrKey, newItem) =>
        setForm((f) => ({ ...f, [arrKey]: [...f[arrKey], newItem] }));
    const removeArrayItem = (arrKey, index) =>
        setForm((f) => ({ ...f, [arrKey]: f[arrKey].filter((_, i) => i !== index) }));

    /* ------------------------- upload utils ------------------------ */
    const uploadFileAndGetUrl = async (file, progressKey = "file", { maxMb = MAX_IMG_MB } = {}) => {
        if (!file) return "";
        if (!ACCEPTED_IMG.includes(file.type)) {
            toast.warn("Please upload JPG/PNG/WEBP image.");
            return "";
        }
        if (file.size > maxMb * 1024 * 1024) {
            toast.warn(`Image must be under ${maxMb} MB.`);
            return "";
        }

        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const fd = new FormData();
        fd.append("file", file);

        try {
            setUploadProgress((p) => ({ ...p, [progressKey]: 1 }));
            const resp = await post(API.events.fileUploader, fd, {
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                    "Content-Type": "multipart/form-data",
                },
            });
            const url =
                resp?.url ||
                resp?.resp?.url ||
                resp?.fileUrl ||
                resp?.location ||
                resp?.path ||
                resp?.secure_url ||
                "";

            if (!url) throw new Error("Upload success but no URL returned.");
            toast.success("Image uploaded ✅");
            return url;
        } catch (e) {
            console.error(e);
            toast.error("Upload failed ❌");
            return "";
        } finally {
            setUploadProgress((p) => ({ ...p, [progressKey]: 0 }));
        }
    };

    const handlePosterFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const url = await uploadFileAndGetUrl(file, "poster", { maxMb: BANNER_MAX_MB });
        if (url) onChange("imageUrl", url);
        e.target.value = "";
    };

    const handleLandscapeFile = async (e, index) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const url = await uploadFileAndGetUrl(file, `landscape-${index}`, { maxMb: BANNER_MAX_MB });
        if (url) {
            const imgs = ensureLandscapeSlots(form.landsacpImage);
            imgs[index] = url;
            onChange("landsacpImage", imgs);
        }
        e.target.value = "";
    };

    const clearLandscapeSlot = (index) => {
        const imgs = ensureLandscapeSlots(form.landsacpImage);
        imgs[index] = "";
        onChange("landsacpImage", imgs);
    };

    const handleLayoutImageFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const url = await uploadFileAndGetUrl(file, "layout");
        if (url) onChange("layoutImage", url);
        e.target.value = "";
    };

    const handleSponsorLogoFile = async (e, index) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const url = await uploadFileAndGetUrl(file, `sponsor-${index}`);
        if (url) onArrayChange("sponsors", index, "logo", url);
        e.target.value = "";
    };

    const handleOrganizerLogoFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const url = await uploadFileAndGetUrl(file, "organizer");
        if (url) onNestedChange("organizer", "logoUrl", url);
        e.target.value = "";
    };

    const handleVenueLogoFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const url = await uploadFileAndGetUrl(file, "venue");
        if (url) onNestedChange("venue", "logoUrl", url);
        e.target.value = "";
    };

    const updateGalleryFolder = (folderName, patch) => {
        setForm((f) => {
            const list = Array.isArray(f.gallery) && f.gallery.length
                ? f.gallery.map((g) => ({ ...g }))
                : emptyGalleryFolders();
            const idx = list.findIndex((g) => g.folder === folderName);
            if (idx < 0) {
                list.push({ folder: folderName, images: [], videos: [], ...patch });
            } else {
                list[idx] = { ...list[idx], ...patch };
            }
            return { ...f, gallery: list };
        });
    };

    const activeGallery =
        (form.gallery || []).find((g) => g.folder === activeGalleryFolder) || {
            folder: activeGalleryFolder,
            images: [],
            videos: [],
        };

    const handleGalleryImageFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const folder = activeGalleryFolder;
        const url = await uploadFileAndGetUrl(file, `gallery-${folder}`);
        if (url) {
            setForm((f) => {
                const list = Array.isArray(f.gallery) && f.gallery.length
                    ? f.gallery.map((g) => ({ ...g, images: [...(g.images || [])], videos: [...(g.videos || [])] }))
                    : emptyGalleryFolders();
                const idx = list.findIndex((g) => g.folder === folder);
                if (idx < 0) {
                    list.push({ folder, images: [url], videos: [] });
                } else {
                    list[idx] = {
                        ...list[idx],
                        images: [...(list[idx].images || []), url],
                    };
                }
                return { ...f, gallery: list };
            });
        }
        e.target.value = "";
    };

    const addGalleryVideo = () => {
        const url = galleryVideoDraft.trim();
        if (!url) return toast.warn("Paste a YouTube URL first.");
        const folder = activeGalleryFolder;
        setForm((f) => {
            const list = Array.isArray(f.gallery) && f.gallery.length
                ? f.gallery.map((g) => ({ ...g, images: [...(g.images || [])], videos: [...(g.videos || [])] }))
                : emptyGalleryFolders();
            const idx = list.findIndex((g) => g.folder === folder);
            if (idx < 0) {
                list.push({ folder, images: [], videos: [url] });
            } else {
                list[idx] = {
                    ...list[idx],
                    videos: [...(list[idx].videos || []), url],
                };
            }
            return { ...f, gallery: list };
        });
        setGalleryVideoDraft("");
        toast.success("Video link added");
    };

    const minScheduleDate = minDateISO(now);

    const applyScheduleDays = (nextDays) => {
        const legacy = syncScheduleToLegacy(nextDays, form.duration);
        setForm((f) => ({
            ...f,
            scheduleDays: nextDays,
            date: legacy.date,
            eventEndDate: legacy.eventEndDate,
            showtimes: legacy.showtimes,
        }));
    };

    const updateScheduleDay = (index, patch) => {
        const next = (form.scheduleDays || [emptyScheduleDay()]).map((d, i) =>
            i === index ? { ...d, ...patch } : d
        );
        applyScheduleDays(next);
    };

    const updateScheduleTime = (dayIndex, timeIndex, value) => {
        const next = (form.scheduleDays || [emptyScheduleDay()]).map((d, i) => {
            if (i !== dayIndex) return d;
            const times = [...(d.times || [""])];
            times[timeIndex] = value;
            return { ...d, times };
        });
        applyScheduleDays(next);
    };

    const addScheduleTime = (dayIndex) => {
        const next = (form.scheduleDays || [emptyScheduleDay()]).map((d, i) =>
            i === dayIndex ? { ...d, times: [...(d.times || []), ""] } : d
        );
        applyScheduleDays(next);
    };

    const removeScheduleTime = (dayIndex, timeIndex) => {
        const next = (form.scheduleDays || [emptyScheduleDay()]).map((d, i) => {
            if (i !== dayIndex) return d;
            const times = (d.times || []).filter((_, ti) => ti !== timeIndex);
            return { ...d, times: times.length ? times : [""] };
        });
        applyScheduleDays(next);
    };

    const removeScheduleDay = (dayIndex) => {
        const list = form.scheduleDays || [];
        if (list.length <= 1) {
            applyScheduleDays([emptyScheduleDay()]);
            return;
        }
        applyScheduleDays(list.filter((_, i) => i !== dayIndex));
    };

    const venueScheduleLabel = form.venue?.name
        ? form.venue.city
            ? `${form.venue.name}: ${form.venue.city}`
            : form.venue.name
        : form.venue?.city || "Venue";

    const scheduleLines = scheduleSummaryLines(form.scheduleDays);

    /* --------------------------- submit ---------------------------- */
    const descText = String(form.description || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .trim();

    const stepComplete = {
        details: Boolean(
            form.name.trim() &&
            form.category &&
            form.subcategories?.length &&
            form.genres?.length &&
            descText &&
            form.duration !== "" &&
            Number(form.duration) > 0
        ),
        additional: (form.termsAndConditions || []).some((t) => String(t.point || "").trim()),
        posters: Boolean(form.imageUrl),
        venue: Boolean(form.venue.address?.trim() && form.venue.city?.trim()),
        schedule: isScheduleComplete(form.scheduleDays, showAdminPublish ? null : minScheduleDate),
        tickets: Boolean(
            (form.ticketCategories || []).some(
                (t) =>
                    String(t.type || "").trim() &&
                    t.price !== "" &&
                    Number(t.price) >= 0 &&
                    t.isTicketAvailable
            )
        ),
    };

    const scheduleDates = listScheduleDates(form.scheduleDays);

    useEffect(() => {
        if (!scheduleDates.length) {
            setTicketDateTab("");
            return;
        }
        setTicketDateTab((prev) =>
            scheduleDates.some((d) => d.date === prev) ? prev : scheduleDates[0].date
        );
    }, [scheduleDates.map((d) => d.date).join("|")]);

    const emptyTicket = (date = "") => ({
        type: "",
        date: date || ticketDateTab || scheduleDates[0]?.date || "",
        price: "",
        currency: "INR",
        totalSeats: "",
        availableSeats: "",
        perks: [],
        isTicketAvailable: true,
    });

    const createNewTicket = (forDate) => {
        const date =
            forDate ||
            ticketDateTab ||
            scheduleDates[0]?.date ||
            "";
        if (scheduleDates.length && !date) {
            toast.warn("Add schedule dates first, then create tickets for each date.");
            return;
        }
        const next = [...(form.ticketCategories || []), emptyTicket(date)];
        onChange("ticketCategories", next);
        setEditingTicketIndex(next.length - 1);
        if (date) setTicketDateTab(date);
    };

    const applyTncTemplate = (templateValue) => {
        setForm((f) => ({
            ...f,
            tncTemplate: templateValue,
            termsHtml: templateToHtml(templateValue),
            termsAndConditions: templateToPoints(templateValue),
        }));
    };

    const onTermsHtmlChange = (html) => {
        setForm((f) => ({
            ...f,
            termsHtml: html,
            termsAndConditions: htmlToPoints(html),
        }));
    };

    const validateStep = (id) => {
        // Superadmin admin-edit: no blocking field validations
        if (showAdminPublish) return true;
        setStepErrors(true);
        if (id === "details") {
            if (!form.name.trim()) return toast.warn("Please enter event name.");
            if (!form.category) return toast.warn("Please select an event category.");
            if (!form.subcategories?.length) return toast.warn("Please select an event sub category.");
            if (!form.genres?.length) return toast.warn("Please select an event genre.");
            if (!descText) return toast.warn("Please add a description.");
            if (form.duration === "" || Number(form.duration) <= 0)
                return toast.warn("Please enter a valid Duration (minutes).");
            return true;
        }
        if (id === "additional") {
            const points = htmlToPoints(form.termsHtml || "");
            const hasTc = points.some((t) => String(t.point || "").trim().length > 0);
            if (!hasTc) return toast.warn("Please add Terms & Conditions for your event.");
            return true;
        }
        if (id === "posters") {
            if (!form.imageUrl) return toast.warn("Please upload a poster image.");
            return true;
        }
        if (id === "venue") {
            if (!form.venue.address.trim()) return toast.warn("Please enter venue address.");
            if (!form.venue.city.trim()) return toast.warn("Please enter venue city.");
            return true;
        }
        if (id === "schedule") {
            const days = form.scheduleDays || [];
            const activeDays = days.filter((d) => d.active);
            if (!activeDays.length) return toast.warn("Add at least one active schedule day.");
            for (const d of activeDays) {
                if (!d.date) return toast.warn("Please select a date for each active day.");
                if (!showAdminPublish && !isEditMode && d.date < minScheduleDate)
                    return toast.warn("Schedule dates must be after today.");
                if (!(d.times || []).some((t) => String(t || "").trim()))
                    return toast.warn("Please add at least one start time for each day.");
            }
            // Ensure legacy fields stay in sync
            applyScheduleDays(days);
            return true;
        }
        if (id === "tickets") {
            const list = form.ticketCategories || [];
            if (!list.length) return toast.warn("Create at least one ticket type.");
            const valid = list.filter((t) => String(t.type || "").trim());
            if (!valid.length) return toast.warn("Please name your ticket types.");
            for (const t of valid) {
                if (scheduleDates.length && !t.date) {
                    return toast.warn(`Assign a date for ticket “${t.type}”.`);
                }
                if (t.price === "" || Number(t.price) < 0)
                    return toast.warn(`Enter a valid price for “${t.type}”.`);
                if (t.totalSeats === "" || Number(t.totalSeats) <= 0)
                    return toast.warn(`Enter total seats for “${t.type}”.`);
            }
            // Every schedule date must have at least one ticket
            for (const day of scheduleDates) {
                const has = valid.some((t) => t.date === day.date);
                if (!has) {
                    return toast.warn(
                        `Create at least one ticket for ${day.shortLabel || day.label}.`
                    );
                }
            }
            const hasAnyAvailable = valid.some((t) => t.isTicketAvailable);
            if (!hasAnyAvailable)
                return toast.warn("At least one ticket type must be ACTIVE.");
            return true;
        }
        return true;
    };

    const validate = () => {
        if (showAdminPublish) return true;
        for (const step of CREATE_EVENT_STEPS) {
            if (!validateStep(step.id)) return false;
        }
        if (form.ageRestriction === "" || Number(form.ageRestriction) < 0)
            return toast.warn("Please enter a valid Age Restriction.");
        return true;
    };

    const goNextStep = () => {
        const current = CREATE_EVENT_STEPS[stepIndex];
        if (!validateStep(current.id)) return;
        if (current.id === "venue") setVenueEditing(false);
        setStepErrors(false);
        setStepIndex((i) => Math.min(i + 1, CREATE_EVENT_STEPS.length - 1));
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const goBack = () => {
        const dirty =
            form.name || form.description || form.imageUrl || form.venue.address || form.ticketCategories?.some(t => t.type || t.price);
        if (dirty && !confirm("You have unsaved changes. Leave this page?")) return;
        if (exitTo) navigate(exitTo);
        else navigate(-1);
    };

    const goPrevStep = () => {
        setStepErrors(false);
        if (stepIndex === 0) {
            goBack();
            return;
        }
        setStepIndex((i) => Math.max(i - 1, 0));
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        // Only final step submits; intermediate uses Save & Proceed
        if (stepIndex < CREATE_EVENT_STEPS.length - 1) {
            goNextStep();
            return;
        }
        if (!validate()) return;

        try {
            setLoading(true);
            const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
            const synced = {
                ...form,
                subcategory: form.subcategories?.[0] || form.subcategory || "",
                language: (form.languages || []).join(", ") || form.language || "",
                ageRestriction: Number(form.ageRestriction) || 0,
                performers: (form.performers || []).filter((p) => String(p.name || "").trim()),
                usps: (form.usps || []).filter((u) => String(u || "").trim()),
                termsAndConditions: htmlToPoints(form.termsHtml || pointsToHtml(form.termsAndConditions)),
                faqs: (form.faqs || []).filter(
                    (f) => String(f.question || "").trim() || String(f.answer || "").trim()
                ),
                youShouldKnow: (form.youShouldKnow || []).filter(
                    (y) => String(y.title || "").trim() || String(y.body || "").trim()
                ),
                landsacpImage: ensureLandscapeSlots(form.landsacpImage).filter(Boolean),
                gallery: (form.gallery || [])
                    .map((g) => ({
                        folder: g.folder,
                        images: (g.images || []).filter(Boolean),
                        videos: (g.videos || []).filter(Boolean),
                    }))
                    .filter((g) => g.images.length || g.videos.length),
                galleryDescription: String(form.galleryDescription || "").slice(0, GALLERY_DESC_MAX),
                promoVideoUrl: String(form.promoVideoUrl || "").trim(),
                scheduleDays: (form.scheduleDays || [])
                    .filter((d) => d.active && d.date)
                    .map((d) => ({
                        active: true,
                        date: d.date,
                        times: (d.times || []).filter(Boolean),
                        recurring: !!d.recurring,
                    })),
                ticketCategories: (form.ticketCategories || [])
                    .filter((t) => String(t.type || "").trim())
                    .map((t) => {
                        const date = String(t.date || "").trim();
                        const rawName = ticketDisplayName(t.type);
                        return {
                            ...t,
                            type: uniqueTicketType(rawName, date),
                            date,
                            availableSeats: t.totalSeats,
                            perks: [],
                        };
                    }),
            };
            // UI-only fields
            delete synced.termsHtml;
            delete synced.tncTemplate;
            delete synced.eventEndDate;
            delete synced.gstRatePercent;
            if (form.eventEndDate) synced.endDate = form.eventEndDate;

            if (showAdminPublish) {
                const gstPct = Number(form.gstRatePercent);
                synced.gstRate =
                    Number.isFinite(gstPct) && form.gstRatePercent !== "" ? gstPct / 100 : 0;
                synced.conveniencesFeeType = form.conveniencesFeeType || "convenienceFeeFlat";
                if (synced.conveniencesFeeType === "convenienceFeePercent") {
                    const feePct = Number(form.convenienceFeePercent);
                    // Store as fraction (8% → 0.08) to match pricing engine
                    synced.convenienceFeePercent =
                        Number.isFinite(feePct) && form.convenienceFeePercent !== ""
                            ? feePct / 100
                            : 0;
                    synced.convenienceFeeFlat = 0;
                } else {
                    synced.convenienceFeeFlat = Number(form.convenienceFeeFlat) || 0;
                    synced.convenienceFeePercent = 0;
                }
            } else {
                delete synced.conveniencesFeeType;
                delete synced.convenienceFeeFlat;
                delete synced.convenienceFeePercent;
                delete synced.gstRate;
            }

            const payload = isSuperadmin
                ? synced
                : Object.fromEntries(
                    Object.entries(synced).filter(([key]) =>
                        !["approvalStatus", "isActived", "isBookingOpen", "isVerified", "ratings", "remark",
                            "gstRate", "conveniencesFeeType", "convenienceFeeFlat", "convenienceFeePercent"].includes(key)
                    )
                );

            const tokenHeaders = {
                "Content-Type": "application/json",
                Authorization: token ? `Bearer ${token}` : undefined,
            };

            if (isEditMode) {
                await put(`${API.events.editEvent}/${eventId}`, payload, { headers: tokenHeaders });
                toast.success("Event updated successfully.");
            } else {
                await post(API.events.createEvent, payload, { headers: tokenHeaders });
                toast.success(isSuperadmin ? "Event created successfully." : "Event submitted for review.");
            }
            setTimeout(() => navigate(successRedirect), 900);
        } catch (err) {
            console.error(err);
            if (isOrganizerApprovalError(err)) {
                toast.warn(err.message || "Complete organizer account verification before creating an event.");
                navigate("/listyourshow/account-setup", { replace: true });
                return;
            }
            toast.error(err.message || (isEditMode ? "Failed to update event" : "Failed to create event"));
        } finally {
            setLoading(false);
        }
    };

    const currentStep = CREATE_EVENT_STEPS[stepIndex];
    const isLastStep = stepIndex === CREATE_EVENT_STEPS.length - 1;

    const addPerformer = () => {
        const name = performerQuery.trim();
        if (!name) return;
        if ((form.performers || []).some((p) => p.name.toLowerCase() === name.toLowerCase())) {
            toast.warn("Performer already added.");
            return;
        }
        addArrayItem("performers", { name, roles: ["Artist"], imageUrl: "" });
        setPerformerQuery("");
    };

    /* ----------------------------- UI ----------------------------- */
    if (bootLoading) {
        return (
            <div className="grid min-h-[50vh] place-items-center bg-[#eef1f5] px-4">
                <div className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm">
                    <FaSpinner className="animate-spin text-amber-500" /> Loading event…
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#eef1f5]">
            <div className="mx-auto max-w-6xl px-4 py-6 pb-28 md:px-6">
                {/* Top bar */}
                <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={goBack}
                            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
                        >
                            <FaArrowLeft /> Exit
                        </button>
                        <div>
                            <p className="text-xs font-medium text-slate-500">
                                Manage Event &gt; {isEditMode ? "Edit" : "Create"} &gt; {currentStep.label}
                            </p>
                            <h1 className="text-xl font-extrabold text-slate-900 md:text-2xl">
                                {isEditMode ? "Edit Event" : "Create Event"}
                            </h1>
                        </div>
                    </div>
                    <span className={cn(
                        "rounded-full px-3 py-1 text-xs font-semibold",
                        isSuperadmin && form.isActived ? "bg-emerald-100 text-emerald-700" : "bg-amber-100 text-amber-800"
                    )}>
                        {isSuperadmin ? (form.isActived ? "Active" : "Inactive") : "Submits as pending"}
                    </span>
                </div>

                <form
                    onSubmit={onSubmit}
                    noValidate={showAdminPublish}
                    className="flex flex-col gap-5 lg:flex-row lg:items-start"
                >
                    {/* Step nav */}
                    <aside className="w-full shrink-0 lg:sticky lg:top-4 lg:w-56">
                        <nav className="space-y-2">
                            {CREATE_EVENT_STEPS.map((step, idx) => {
                                const active = idx === stepIndex;
                                const done = stepComplete[step.id];
                                return (
                                    <div key={step.id} className="space-y-1">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (idx <= stepIndex || done) {
                                                setStepIndex(idx);
                                                setStepErrors(false);
                                            }
                                        }}
                                        className={cn(
                                            "flex w-full items-center justify-between rounded-xl border bg-white px-3 py-3 text-left text-sm font-semibold shadow-sm transition",
                                            active
                                                ? "border-amber-300 ring-2 ring-amber-100 text-slate-900"
                                                : "border-slate-200 text-slate-700 hover:border-slate-300",
                                            idx > stepIndex && !done && "opacity-70"
                                        )}
                                    >
                                        <span className="flex items-center gap-2">
                                            {active && (
                                                <span className="h-8 w-1 shrink-0 rounded-full bg-amber-500" aria-hidden />
                                            )}
                                            <span className={cn(!active && "pl-3")}>{step.label}</span>
                                        </span>
                                        {done ? (
                                            <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-emerald-500 text-white">
                                                <FaCheck className="h-2.5 w-2.5" />
                                            </span>
                                        ) : null}
                                    </button>
                                    {step.id === "tickets" && active && venueScheduleLabel && (
                                        <p className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-xs font-medium text-slate-600">
                                            {venueScheduleLabel}
                                        </p>
                                    )}
                                    </div>
                                );
                            })}
                        </nav>
                    </aside>

                    {/* Step content */}
                    <div className="min-w-0 flex-1 space-y-5">

            {currentStep.id === "details" && (
                <>
            <Section
                title="Event Details"
                hint="Please add your event's name, relevant categories and other details to ensure optimal discovery."
                complete={stepComplete.details}
            >
                <Input
                    label="Event Name"
                    value={form.name}
                    onChange={(v) => onChange("name", v)}
                    required
                    placeholder="e.g. Sunburn Arena"
                />

                <CategorySubcategoryFields
                    category={form.category}
                    subcategories={form.subcategories}
                    genres={form.genres}
                    languages={form.languages}
                    onCategoryChange={(v) => onChange("category", v)}
                    onSubcategoriesChange={(v) => onChange("subcategories", v)}
                    onGenresChange={(v) => onChange("genres", v)}
                    onLanguagesChange={(v) => onChange("languages", v)}
                    required
                    showErrors={stepErrors}
                />
            </Section>

            <Section
                title="Event Description"
                hint="Share a brief and relevant description and other details about your event that help people understand it better."
                complete={Boolean(descText && form.duration)}
            >
                <div>
                    <Label required>About the event</Label>
                    <div className="mt-1">
                        <RichText
                            label=""
                            value={form.description}
                            onChange={(html) => onChange("description", html)}
                            placeholder="What's special about this event? Add details, headliners, schedule, FAQs, etc."
                            minHeight={220}
                        />
                    </div>
                </div>

                <div className="grid gap-4 md:grid-cols-2">
                    <Select
                        label="Age group (optional)"
                        value={String(form.ageRestriction ?? "0")}
                        onChange={(v) => onChange("ageRestriction", v)}
                        options={AGE_GROUP_OPTIONS.map((o) => o.value)}
                        optionLabels={Object.fromEntries(AGE_GROUP_OPTIONS.map((o) => [o.value, o.label]))}
                    />
                    <Input
                        label="Event duration in minutes"
                        type="number"
                        value={form.duration}
                        onChange={(v) => onChange("duration", v)}
                        required
                        placeholder="e.g. 180"
                    />
                </div>

                <div>
                    <Label>USPs (optional)</Label>
                    <div className="mt-2 space-y-2">
                        {(form.usps || []).map((usp, i) => (
                            <div key={i} className="flex items-center gap-2">
                                <input
                                    className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                                    value={usp}
                                    onChange={(e) => {
                                        const next = [...form.usps];
                                        next[i] = e.target.value;
                                        onChange("usps", next);
                                    }}
                                    placeholder="Unique selling point…"
                                />
                                <IconButton label="Remove USP" onClick={() => removeArrayItem("usps", i)}>
                                    <FaTrash />
                                </IconButton>
                            </div>
                        ))}
                        <button
                            type="button"
                            onClick={() => onChange("usps", [...(form.usps || []), ""])}
                            className="text-sm font-semibold text-amber-700 hover:text-amber-800"
                        >
                            + Add USPs
                        </button>
                    </div>
                </div>
            </Section>

            <Section
                title="Artist or Performer (Optional)"
                hint="Add artists or performers associated with this event."
                complete={(form.performers || []).length > 0}
            >
                <div>
                    <Label>Select Artist or Performers</Label>
                    <div className="mt-1.5 flex gap-2">
                        <input
                            className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                            placeholder="Start typing here…"
                            value={performerQuery}
                            onChange={(e) => setPerformerQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    addPerformer();
                                }
                            }}
                        />
                        <button
                            type="button"
                            onClick={addPerformer}
                            className="shrink-0 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold hover:bg-slate-50"
                        >
                            Add
                        </button>
                    </div>
                </div>

                {(form.performers || []).length > 0 && (
                    <div className="space-y-3">
                        {form.performers.map((p, i) => (
                            <div key={i} className="flex flex-col gap-3 rounded-xl border border-slate-200 bg-slate-50/60 p-3 sm:flex-row sm:items-center">
                                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-amber-100 text-sm font-bold text-amber-800">
                                    {String(p.name || "?").slice(0, 1).toUpperCase()}
                                </div>
                                <div className="min-w-0 flex-1">
                                    <p className="font-semibold text-slate-900">{p.name}</p>
                                    <div className="mt-1 flex flex-wrap gap-1.5">
                                        {PERFORMER_ROLES.map((role) => {
                                            const active = (p.roles || []).includes(role);
                                            return (
                                                <button
                                                    key={role}
                                                    type="button"
                                                    onClick={() => {
                                                        const roles = active
                                                            ? (p.roles || []).filter((r) => r !== role)
                                                            : [...(p.roles || []), role];
                                                        onArrayChange("performers", i, "roles", roles);
                                                    }}
                                                    className={cn(
                                                        "rounded-md px-2 py-0.5 text-xs font-semibold",
                                                        active
                                                            ? "bg-amber-500 text-white"
                                                            : "bg-white text-slate-600 ring-1 ring-slate-200"
                                                    )}
                                                >
                                                    {role}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                                <IconButton label="Remove performer" onClick={() => removeArrayItem("performers", i)}>
                                    <FaTrash />
                                </IconButton>
                            </div>
                        ))}
                    </div>
                )}
            </Section>
                </>
            )}

            {currentStep.id === "venue" && (
            <>
            <Section
                title="Venue Location"
                hint="Help people in the area discover your event and let attendees know where to show up."
                required
                complete={stepComplete.venue}
            >
                {!venueEditing && stepComplete.venue ? (
                    <>
                        <button
                            type="button"
                            onClick={() => setVenueEditing(true)}
                            className="flex w-full items-center justify-center gap-2 rounded-xl border-2 border-amber-400 bg-white px-4 py-3.5 text-sm font-bold text-amber-700 hover:bg-amber-50"
                        >
                            <FaMapMarkerAlt /> Add New Venue
                        </button>

                        <div className="flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
                            <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-emerald-500 text-white">
                                <FaCheck className="h-2.5 w-2.5" />
                            </span>
                            <div className="min-w-0 flex-1">
                                <p className="font-bold text-emerald-700">
                                    {form.venue.name
                                        ? form.venue.city
                                            ? `${form.venue.name}: ${form.venue.city}`
                                            : form.venue.name
                                        : form.venue.city || "Selected venue"}
                                </p>
                                <p className="mt-1 text-sm leading-relaxed text-slate-600">
                                    {[
                                        form.venue.address,
                                        form.venue.city,
                                        form.venue.state,
                                        form.venue.pincode,
                                        form.venue.country,
                                    ]
                                        .filter(Boolean)
                                        .join(", ")}
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={() => setVenueEditing(true)}
                                className="shrink-0 rounded-lg p-2 text-amber-700 hover:bg-amber-50"
                                title="Edit venue"
                                aria-label="Edit venue"
                            >
                                <FaPencilAlt />
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="space-y-4">
                        <button
                            type="button"
                            onClick={() => {
                                if (stepComplete.venue) setVenueEditing(false);
                            }}
                            className="flex w-full items-center justify-center gap-2 rounded-xl border-2 border-amber-400 bg-amber-50/60 px-4 py-3.5 text-sm font-bold text-amber-800"
                        >
                            <FaMapMarkerAlt /> {stepComplete.venue ? "Editing venue" : "Add New Venue"}
                        </button>

                        <AddressPicker
                            value={form.venue}
                            onPick={(patch) => {
                                Object.entries(patch).forEach(([k, v]) => onNestedChange("venue", k, v ?? ""));
                                toast.success("Address filled from map ✅");
                            }}
                        />

                        <div className="grid gap-4 md:grid-cols-2">
                            {["name", "address", "city", "state", "country", "pincode", "latitude", "longitude", "capacity"]
                                .map((k) => (
                                    <Input
                                        key={k}
                                        label={capitalize(k)}
                                        value={form.venue[k]}
                                        onChange={(v) => onNestedChange("venue", k, v)}
                                        type={["latitude", "longitude", "capacity"].includes(k) ? "number" : "text"}
                                        required={["address", "city"].includes(k)}
                                    />
                                ))}
                        </div>

                        <Uploader
                            label="Venue Logo (optional)"
                            progress={uploadProgress["venue"] > 0}
                            onFile={handleVenueLogoFile}
                            previewUrl={form.venue.logoUrl}
                            onClear={() => onNestedChange("venue", "logoUrl", "")}
                        />

                        {stepComplete.venue && (
                            <div className="flex justify-end">
                                <button
                                    type="button"
                                    onClick={() => setVenueEditing(false)}
                                    className="rounded-lg bg-amber-400 px-5 py-2.5 text-sm font-bold text-slate-900 hover:bg-amber-500"
                                >
                                    Save venue
                                </button>
                            </div>
                        )}
                    </div>
                )}

                <div className="rounded-xl border border-amber-200 border-l-4 border-l-amber-400 bg-amber-50 px-4 py-3 text-sm text-amber-950">
                    <span className="font-semibold">Please Note:</span>{" "}
                    ShowTimeBro currently focuses on general admission / open events. For fully seated
                    layouts and reserved seating setup, contact support after listing your event.
                </div>
            </Section>
            </>
            )}

            {currentStep.id === "tickets" && (
            <>
            <Section
                title="Create Tickets"
                hint={
                    scheduleDates.length > 1
                        ? "Create separate ticket types for each event date — price and capacity are per date."
                        : scheduleDates.length === 1
                          ? `Add ticket types for ${scheduleDates[0].shortLabel} — name, price and capacity.`
                          : "Add ticket types for your shows — name, price and capacity."
                }
                complete={stepComplete.tickets}
                required
                headerAction={
                    <button
                        type="button"
                        onClick={() => createNewTicket(ticketDateTab)}
                        className="inline-flex items-center gap-2 rounded-lg bg-amber-400 px-4 py-2 text-sm font-bold text-slate-900 shadow-sm hover:bg-amber-500"
                    >
                        <FaPlus className="h-3 w-3" /> Create ticket
                    </button>
                }
            >
                {/* Venue + schedule dates */}
                <div className="rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-50 to-white p-4">
                    <div className="flex flex-wrap items-start justify-between gap-3">
                        <div>
                            <p className="text-xs font-semibold uppercase tracking-wide text-slate-400">
                                Venue
                            </p>
                            <p className="mt-0.5 text-base font-bold text-slate-900">
                                {venueScheduleLabel}
                            </p>
                        </div>
                        {scheduleDates.length > 0 && (
                            <p className="rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-700 ring-1 ring-emerald-100">
                                {scheduleDates.length} date{scheduleDates.length > 1 ? "s" : ""}
                            </p>
                        )}
                    </div>

                    {scheduleDates.length > 0 ? (
                        <div className="mt-3 flex flex-wrap gap-2">
                            {scheduleDates.map((day) => {
                                const count = (form.ticketCategories || []).filter(
                                    (t) => t.date === day.date && String(t.type || "").trim()
                                ).length;
                                const active = ticketDateTab === day.date;
                                return (
                                    <button
                                        key={day.date}
                                        type="button"
                                        onClick={() => setTicketDateTab(day.date)}
                                        className={cn(
                                            "inline-flex items-center gap-2 rounded-lg px-3 py-1.5 text-xs font-semibold ring-1 transition",
                                            active
                                                ? "bg-amber-400 text-slate-900 ring-amber-500"
                                                : "bg-white text-slate-700 ring-slate-200 hover:ring-amber-300"
                                        )}
                                    >
                                        {day.shortLabel}
                                        <span
                                            className={cn(
                                                "rounded-full px-1.5 py-0.5 text-[10px] font-bold",
                                                active ? "bg-white/70 text-slate-800" : "bg-slate-100 text-slate-600"
                                            )}
                                        >
                                            {count} ticket{count === 1 ? "" : "s"}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    ) : (
                        <p className="mt-3 text-sm text-slate-500">
                            No schedule dates yet — add dates in{" "}
                            <button
                                type="button"
                                className="font-semibold text-amber-700 underline underline-offset-2 hover:text-amber-800"
                                onClick={() => {
                                    const idx = CREATE_EVENT_STEPS.findIndex((s) => s.id === "schedule");
                                    if (idx >= 0) {
                                        setStepIndex(idx);
                                        setStepErrors(false);
                                    }
                                }}
                            >
                                Event Schedule
                            </button>{" "}
                            first, then create tickets for each date.
                        </p>
                    )}
                </div>

                {scheduleDates.length > 0 && ticketDateTab && (
                    <p className="text-sm font-semibold text-slate-700">
                        Tickets for{" "}
                        <span className="text-amber-800">
                            {scheduleDates.find((d) => d.date === ticketDateTab)?.shortLabel ||
                                formatDayLabel(ticketDateTab)}
                        </span>
                    </p>
                )}

                {/* Ticket list (filtered by selected date when multi-day) */}
                {(() => {
                    const all = form.ticketCategories || [];
                    const indices = all
                        .map((t, i) => i)
                        .filter((i) => {
                            if (!scheduleDates.length) return true;
                            return all[i].date === ticketDateTab;
                        });

                    if (!indices.length) {
                        return (
                            <div className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-300 bg-slate-50/80 px-6 py-14 text-center">
                                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-100 text-amber-700">
                                    <FaPlus className="h-5 w-5" />
                                </div>
                                <h3 className="mt-4 text-base font-bold text-slate-900">
                                    {scheduleDates.length
                                        ? "No tickets for this date yet"
                                        : "No tickets yet"}
                                </h3>
                                <p className="mt-1 max-w-sm text-sm text-slate-500">
                                    {scheduleDates.length
                                        ? "Create types like GOLD, VIP or GA for this date only."
                                        : "Create types like GOLD, VIP or GA with price and seat capacity."}
                                </p>
                                <button
                                    type="button"
                                    onClick={() => createNewTicket(ticketDateTab)}
                                    className="mt-5 inline-flex items-center gap-2 rounded-lg bg-amber-400 px-5 py-2.5 text-sm font-bold text-slate-900 hover:bg-amber-500"
                                >
                                    <FaPlus className="h-3 w-3" /> Create ticket for this date
                                </button>
                            </div>
                        );
                    }

                    return (
                        <div className="space-y-3">
                            {indices.map((i) => {
                                const t = all[i];
                                const total = Number(t.totalSeats) || 0;
                                const isEditing = editingTicketIndex === i;
                                const active = !!t.isTicketAvailable;
                                const displayType = ticketDisplayName(t.type);

                                if (isEditing) {
                                    return (
                                        <div
                                            key={i}
                                            className="rounded-2xl border border-amber-300 bg-white p-5 shadow-sm ring-2 ring-amber-100"
                                        >
                                            <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
                                                <p className="text-sm font-bold text-slate-900">
                                                    {displayType ? `Edit · ${displayType}` : "New ticket"}
                                                </p>
                                                <div className="flex items-center gap-2">
                                                    {t.date ? (
                                                        <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold text-slate-700">
                                                            {formatDayLabel(t.date)}
                                                        </span>
                                                    ) : null}
                                                    <span className="rounded-full bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-800">
                                                        Editing
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="grid gap-4 sm:grid-cols-3">
                                                <Input
                                                    label="Ticket name"
                                                    value={displayType}
                                                    onChange={(v) =>
                                                        onArrayChange("ticketCategories", i, "type", v)
                                                    }
                                                    placeholder="e.g. GOLD / VIP PASS"
                                                    required
                                                />
                                                <Input
                                                    label="Price (₹)"
                                                    type="number"
                                                    value={t.price}
                                                    onChange={(v) =>
                                                        onArrayChange("ticketCategories", i, "price", v)
                                                    }
                                                    required
                                                />
                                                <Input
                                                    label="Total seats / capacity"
                                                    type="number"
                                                    value={t.totalSeats}
                                                    onChange={(v) => {
                                                        onArrayChange("ticketCategories", i, "totalSeats", v);
                                                        onArrayChange("ticketCategories", i, "availableSeats", v);
                                                    }}
                                                    required
                                                />
                                            </div>
                                            {scheduleDates.length > 1 && (
                                                <div className="mt-4">
                                                    <label className="mb-1.5 block text-xs font-semibold text-slate-600">
                                                        Applies to date *
                                                    </label>
                                                    <select
                                                        value={t.date || ""}
                                                        onChange={(e) => {
                                                            onArrayChange(
                                                                "ticketCategories",
                                                                i,
                                                                "date",
                                                                e.target.value
                                                            );
                                                            if (e.target.value) setTicketDateTab(e.target.value);
                                                        }}
                                                        className="w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm font-medium text-slate-800"
                                                    >
                                                        <option value="">Select date</option>
                                                        {scheduleDates.map((d) => (
                                                            <option key={d.date} value={d.date}>
                                                                {d.shortLabel}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            )}
                                            <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-4">
                                                <Toggle
                                                    label="ACTIVE"
                                                    checked={active}
                                                    onChange={(v) =>
                                                        onArrayChange(
                                                            "ticketCategories",
                                                            i,
                                                            "isTicketAvailable",
                                                            v
                                                        )
                                                    }
                                                />
                                                <div className="flex gap-2">
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if (!String(t.type || "").trim()) {
                                                                removeArrayItem("ticketCategories", i);
                                                            }
                                                            setEditingTicketIndex(null);
                                                        }}
                                                        className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-50"
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            if (!String(t.type || "").trim()) {
                                                                return toast.warn("Enter a ticket name.");
                                                            }
                                                            if (scheduleDates.length && !t.date) {
                                                                return toast.warn("Select a date for this ticket.");
                                                            }
                                                            if (t.price === "" || Number(t.price) < 0) {
                                                                return toast.warn("Enter a valid price.");
                                                            }
                                                            if (!t.totalSeats || Number(t.totalSeats) <= 0) {
                                                                return toast.warn("Enter total seats.");
                                                            }
                                                            setEditingTicketIndex(null);
                                                        }}
                                                        className="rounded-lg bg-amber-400 px-5 py-2 text-sm font-bold text-slate-900 hover:bg-amber-500"
                                                    >
                                                        Save ticket
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                }

                                return (
                                    <div
                                        key={i}
                                        className={cn(
                                            "group rounded-2xl border bg-white p-4 shadow-sm transition hover:border-slate-300 hover:shadow-md",
                                            active ? "border-slate-200" : "border-slate-200 opacity-75"
                                        )}
                                    >
                                        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                                            <div className="min-w-0 flex-1">
                                                <div className="flex flex-wrap items-center gap-2">
                                                    <h3 className="text-base font-extrabold uppercase tracking-wide text-slate-900">
                                                        {displayType || "Untitled ticket"}
                                                    </h3>
                                                    {t.date ? (
                                                        <span className="rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-bold text-slate-600">
                                                            {formatDayLabel(t.date)}
                                                        </span>
                                                    ) : null}
                                                    <span
                                                        className={cn(
                                                            "rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide",
                                                            active
                                                                ? "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100"
                                                                : "bg-slate-100 text-slate-500 ring-1 ring-slate-200"
                                                        )}
                                                    >
                                                        {active ? "Active" : "Inactive"}
                                                    </span>
                                                </div>
                                                <div className="mt-3 flex flex-wrap items-end gap-6">
                                                    <div>
                                                        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-400">
                                                            Price
                                                        </p>
                                                        <p className="text-lg font-bold text-slate-900">
                                                            ₹
                                                            {t.price === ""
                                                                ? "—"
                                                                : Number(t.price).toLocaleString("en-IN")}
                                                        </p>
                                                    </div>
                                                    <div className="min-w-[140px] flex-1 sm:max-w-[200px]">
                                                        <div className="mb-1 flex items-center justify-between text-[11px] font-medium text-slate-500">
                                                            <span>Capacity</span>
                                                            <span>{total.toLocaleString("en-IN")} seats</span>
                                                        </div>
                                                        <div className="h-2 overflow-hidden rounded-full bg-slate-100">
                                                            <div className="h-full w-full rounded-full bg-gradient-to-r from-amber-300 to-amber-500" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="flex items-center gap-2 sm:gap-3">
                                                <Toggle
                                                    label="ACTIVE"
                                                    checked={active}
                                                    onChange={(v) =>
                                                        onArrayChange(
                                                            "ticketCategories",
                                                            i,
                                                            "isTicketAvailable",
                                                            v
                                                        )
                                                    }
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => setEditingTicketIndex(i)}
                                                    className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={() => removeArrayItem("ticketCategories", i)}
                                                    className="rounded-lg p-2 text-slate-400 hover:bg-rose-50 hover:text-rose-600"
                                                    title="Delete ticket"
                                                    aria-label="Delete ticket"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}

                            <button
                                type="button"
                                onClick={() => createNewTicket(ticketDateTab)}
                                className="flex w-full items-center justify-center gap-2 rounded-2xl border border-dashed border-slate-300 bg-white py-3.5 text-sm font-bold text-slate-600 hover:border-amber-400 hover:bg-amber-50/50 hover:text-amber-800"
                            >
                                <FaPlus className="h-3 w-3" /> Add another ticket for this date
                            </button>
                        </div>
                    );
                })()}
            </Section>
            </>
            )}

            {currentStep.id === "schedule" && (
            <>
            <Section
                title="Event Schedule"
                hint="Let people know the exact scheduled timings and dates for your event at various venues so they can choose when and where they wish to attend."
                tone="warn"
                complete={stepComplete.schedule}
                required
            >
                <div className="rounded-xl border border-slate-200 bg-slate-50/70 px-4 py-3">
                    <p className="text-sm font-bold text-slate-900">{venueScheduleLabel}</p>
                    {scheduleLines.length > 0 ? (
                        <ul className="mt-2 space-y-1 text-sm text-slate-600">
                            {scheduleLines.map((line) => (
                                <li key={line}>• {line}</li>
                            ))}
                        </ul>
                    ) : (
                        <p className="mt-1 text-sm text-slate-500">No showtimes added yet.</p>
                    )}
                </div>

                <div className="space-y-0 divide-y divide-slate-200 rounded-xl border border-slate-200 bg-white">
                    {(form.scheduleDays || [emptyScheduleDay()]).map((day, dayIndex) => (
                        <div key={dayIndex} className="space-y-4 p-4">
                            <div className="flex items-center justify-between gap-3">
                                <Toggle
                                    label="ACTIVE"
                                    checked={day.active !== false}
                                    onChange={(v) => updateScheduleDay(dayIndex, { active: v })}
                                />
                                <button
                                    type="button"
                                    onClick={() => removeScheduleDay(dayIndex)}
                                    className="rounded-lg p-2 text-slate-400 hover:bg-rose-50 hover:text-rose-600"
                                    title="Remove day"
                                    aria-label="Remove day"
                                >
                                    <FaTrash />
                                </button>
                            </div>

                            <div className="grid gap-4 sm:grid-cols-2">
                                <div>
                                    <Label required>Date</Label>
                                    <input
                                        type="date"
                                        min={showAdminPublish ? undefined : minScheduleDate}
                                        value={day.date || ""}
                                        onChange={(e) => updateScheduleDay(dayIndex, { date: e.target.value })}
                                        className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                                        disabled={day.active === false}
                                    />
                                </div>
                                <div className="space-y-2">
                                    <Label required>Start Time</Label>
                                    {(day.times || [""]).map((time, timeIndex) => (
                                        <div key={timeIndex} className="flex items-center gap-2">
                                            <input
                                                type="time"
                                                value={time || ""}
                                                onChange={(e) =>
                                                    updateScheduleTime(dayIndex, timeIndex, e.target.value)
                                                }
                                                className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                                                disabled={day.active === false}
                                            />
                                            {(day.times || []).length > 1 && (
                                                <IconButton
                                                    label="Remove time"
                                                    onClick={() => removeScheduleTime(dayIndex, timeIndex)}
                                                >
                                                    <FaTrash />
                                                </IconButton>
                                            )}
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        onClick={() => addScheduleTime(dayIndex)}
                                        disabled={day.active === false}
                                        className="text-sm font-semibold text-amber-700 hover:text-amber-800 disabled:opacity-50"
                                    >
                                        + Add time
                                    </button>
                                </div>
                            </div>

                            <label className="inline-flex items-center gap-2 text-sm text-slate-700">
                                <input
                                    type="checkbox"
                                    checked={!!day.recurring}
                                    onChange={(e) =>
                                        updateScheduleDay(dayIndex, { recurring: e.target.checked })
                                    }
                                    disabled={day.active === false}
                                    className="h-4 w-4 rounded border-slate-300 text-amber-500 focus:ring-amber-300"
                                />
                                Recurring event
                            </label>
                        </div>
                    ))}
                </div>

                <div className="flex justify-center pt-1">
                    <button
                        type="button"
                        onClick={() =>
                            applyScheduleDays([
                                ...(form.scheduleDays || []),
                                emptyScheduleDay(),
                            ])
                        }
                        className="rounded-xl border-2 border-amber-400 bg-white px-5 py-2.5 text-sm font-bold text-amber-800 hover:bg-amber-50"
                    >
                        Add another day
                    </button>
                </div>
            </Section>
            </>
            )}

            {currentStep.id === "posters" && (
            <>
            <Section
                title="Event Banners"
                hint="Upload crisp banners for your event page. Recommended size 1920×960 (2:1). Max 1MB per image (JPG/PNG/WEBP)."
                complete={ensureLandscapeSlots(form.landsacpImage).some(Boolean) || Boolean(form.imageUrl)}
            >
                <div>
                    <Label>Horizontal banners</Label>
                    <p className="mt-1 text-xs text-slate-500">
                        First banner is primary. Extra slots are optional.
                    </p>
                    <div className="mt-3 grid gap-3 sm:grid-cols-2">
                        {ensureLandscapeSlots(form.landsacpImage).map((img, i) => (
                            <div
                                key={i}
                                className="overflow-hidden rounded-xl border border-slate-200 bg-slate-50"
                            >
                                {img ? (
                                    <div>
                                        <img
                                            src={img}
                                            alt={`Banner ${i + 1}`}
                                            className="aspect-[2/1] w-full object-cover"
                                        />
                                        <div className="flex items-center gap-3 px-3 py-2 text-sm">
                                            <button
                                                type="button"
                                                onClick={() => clearLandscapeSlot(i)}
                                                className="inline-flex items-center gap-1 font-semibold text-rose-600 hover:text-rose-700"
                                            >
                                                <FaTrash className="h-3 w-3" /> Remove
                                            </button>
                                            <label className="cursor-pointer font-semibold text-amber-700 hover:text-amber-800">
                                                Edit
                                                <input
                                                    type="file"
                                                    accept={ACCEPTED_IMG.join(",")}
                                                    className="hidden"
                                                    onChange={(e) => handleLandscapeFile(e, i)}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                ) : (
                                    <label className="flex aspect-[2/1] cursor-pointer flex-col items-center justify-center gap-2 text-sm text-slate-500 hover:bg-slate-100">
                                        {uploadProgress[`landscape-${i}`] ? (
                                            <FaSpinner className="animate-spin text-amber-500" />
                                        ) : (
                                            <FaImage className="h-7 w-7 text-slate-300" />
                                        )}
                                        <span className="font-medium">
                                            {i === 0 ? "Upload image" : "Upload image (optional)"}
                                        </span>
                                        <input
                                            type="file"
                                            accept={ACCEPTED_IMG.join(",")}
                                            className="hidden"
                                            onChange={(e) => handleLandscapeFile(e, i)}
                                        />
                                    </label>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
                    <p className="font-semibold">Do’s & don’ts</p>
                    <ul className="mt-1 list-disc space-y-0.5 pl-5 text-amber-800/90">
                        <li>Use unique banners — avoid uploading the same image twice.</li>
                        <li>Keep text large and readable; don’t clutter the edges.</li>
                        <li>Stick to 2:1 ratio for best crop on web and mobile.</li>
                    </ul>
                </div>

                <div className="border-t border-slate-100 pt-4">
                    <Label>Promotional video (optional)</Label>
                    <p className="mt-1 text-xs text-slate-500">Paste a YouTube URL to showcase on the event page.</p>
                    <div className="mt-2 flex flex-col gap-2 sm:flex-row">
                        <input
                            className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                            placeholder="Paste video URL here"
                            value={form.promoVideoUrl || ""}
                            onChange={(e) => onChange("promoVideoUrl", e.target.value)}
                        />
                        <button
                            type="button"
                            disabled
                            title="Direct video upload coming soon — use YouTube URL"
                            className="shrink-0 cursor-not-allowed rounded-lg border border-slate-200 bg-slate-100 px-4 py-2.5 text-sm font-semibold text-slate-400"
                        >
                            Upload Video
                        </button>
                    </div>
                </div>
            </Section>

            <Section
                title="Vertical banner"
                hint="Used as the main event poster. Minimum 500×750 (2:3). Max 1MB (JPG/PNG/WEBP)."
                required
                complete={Boolean(form.imageUrl)}
            >
                <div className="mx-auto max-w-xs">
                    {form.imageUrl ? (
                        <div className="overflow-hidden rounded-xl border border-slate-200 bg-slate-50">
                            <div className="flex items-center justify-end gap-3 px-3 py-2 text-sm">
                                <label className="cursor-pointer font-semibold text-amber-700 hover:text-amber-800">
                                    Edit
                                    <input
                                        type="file"
                                        accept={ACCEPTED_IMG.join(",")}
                                        className="hidden"
                                        onChange={handlePosterFile}
                                    />
                                </label>
                                <button
                                    type="button"
                                    onClick={() => onChange("imageUrl", "")}
                                    className="font-semibold text-rose-600 hover:text-rose-700"
                                >
                                    Remove
                                </button>
                            </div>
                            <img
                                src={form.imageUrl}
                                alt="Vertical banner"
                                className="aspect-[2/3] w-full object-cover"
                            />
                        </div>
                    ) : (
                        <label className="flex aspect-[2/3] cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-slate-300 bg-slate-50 text-sm text-slate-500 hover:bg-slate-100">
                            {uploadProgress.poster ? (
                                <FaSpinner className="animate-spin text-amber-500" />
                            ) : (
                                <FaImage className="h-8 w-8 text-slate-300" />
                            )}
                            <span className="font-semibold text-slate-700">Upload vertical banner</span>
                            <span className="text-xs">2:3 · max 1MB</span>
                            <input
                                type="file"
                                accept={ACCEPTED_IMG.join(",")}
                                className="hidden"
                                onChange={handlePosterFile}
                            />
                        </label>
                    )}
                </div>
            </Section>

            <Section
                title="Gallery (Optional)"
                hint="Organize images into folders so fans can explore F&B, venue vibes, past events and more."
                complete={(form.gallery || []).some(
                    (g) => (g.images || []).length || (g.videos || []).length
                )}
            >
                <div>
                    <Label>Gallery description</Label>
                    <textarea
                        className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                        rows={2}
                        maxLength={GALLERY_DESC_MAX}
                        placeholder="Max. 110 characters — short intro for your gallery"
                        value={form.galleryDescription || ""}
                        onChange={(e) => onChange("galleryDescription", e.target.value)}
                    />
                    <p className="mt-1 text-xs text-slate-500">
                        {GALLERY_DESC_MAX - String(form.galleryDescription || "").length} characters remaining
                    </p>
                </div>

                <div className="overflow-hidden rounded-xl border border-slate-200">
                    <div className="grid md:grid-cols-[200px_1fr]">
                        <div className="border-b border-slate-200 bg-slate-50 md:border-b-0 md:border-r">
                            <p className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-slate-500">
                                Folders
                            </p>
                            <ul className="max-h-72 overflow-auto">
                                {GALLERY_FOLDER_OPTIONS.map((folder) => {
                                    const folderData = (form.gallery || []).find((g) => g.folder === folder);
                                    const count =
                                        (folderData?.images?.length || 0) + (folderData?.videos?.length || 0);
                                    const active = folder === activeGalleryFolder;
                                    return (
                                        <li key={folder}>
                                            <button
                                                type="button"
                                                onClick={() => setActiveGalleryFolder(folder)}
                                                className={cn(
                                                    "flex w-full items-center justify-between px-3 py-2.5 text-left text-sm font-medium",
                                                    active
                                                        ? "bg-amber-100 text-amber-900"
                                                        : "text-slate-700 hover:bg-white"
                                                )}
                                            >
                                                <span>{folder}</span>
                                                {count > 0 && (
                                                    <span className="rounded-full bg-white px-1.5 text-xs text-slate-500 ring-1 ring-slate-200">
                                                        {count}
                                                    </span>
                                                )}
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        <div className="space-y-4 p-4">
                            <p className="text-sm font-semibold text-slate-800">
                                {activeGalleryFolder}
                            </p>
                            <div className="flex flex-wrap gap-2">
                                <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold hover:bg-slate-50">
                                    <FaUpload /> Upload Image
                                    <input
                                        type="file"
                                        accept={ACCEPTED_IMG.join(",")}
                                        className="hidden"
                                        onChange={handleGalleryImageFile}
                                    />
                                </label>
                            </div>

                            <div className="flex flex-col gap-2 sm:flex-row">
                                <input
                                    className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                                    placeholder="Add YouTube video URL"
                                    value={galleryVideoDraft}
                                    onChange={(e) => setGalleryVideoDraft(e.target.value)}
                                />
                                <button
                                    type="button"
                                    onClick={addGalleryVideo}
                                    className="shrink-0 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold hover:bg-slate-50"
                                >
                                    Add Youtube Video
                                </button>
                            </div>

                            {(activeGallery.images || []).length > 0 && (
                                <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
                                    {activeGallery.images.map((url, i) => (
                                        <div key={`${url}-${i}`} className="relative overflow-hidden rounded-lg border">
                                            <img src={url} alt="" className="aspect-square w-full object-cover" />
                                            <button
                                                type="button"
                                                className="absolute right-1 top-1 rounded bg-white/90 p-1 text-rose-600 shadow"
                                                onClick={() =>
                                                    updateGalleryFolder(activeGalleryFolder, {
                                                        images: activeGallery.images.filter((_, idx) => idx !== i),
                                                    })
                                                }
                                            >
                                                <FaTrash className="h-3 w-3" />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {(activeGallery.videos || []).length > 0 && (
                                <ul className="space-y-1 text-sm">
                                    {activeGallery.videos.map((url, i) => (
                                        <li
                                            key={`${url}-${i}`}
                                            className="flex items-center justify-between gap-2 rounded-lg border border-slate-200 px-3 py-2"
                                        >
                                            <span className="truncate text-slate-700">{url}</span>
                                            <button
                                                type="button"
                                                className="shrink-0 text-rose-600"
                                                onClick={() =>
                                                    updateGalleryFolder(activeGalleryFolder, {
                                                        videos: activeGallery.videos.filter((_, idx) => idx !== i),
                                                    })
                                                }
                                            >
                                                <FaTrash />
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            )}

                            {!(activeGallery.images || []).length && !(activeGallery.videos || []).length && (
                                <p className="text-sm text-slate-500">
                                    No media in this folder yet. Upload an image or add a YouTube link.
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
                    <p className="font-semibold">Do’s & don’ts</p>
                    <ul className="mt-1 list-disc space-y-0.5 pl-5 text-amber-800/90">
                        <li>Upload only folder-relevant images (e.g. food shots under F&B).</li>
                        <li>Prefer bright, high-quality photos over screenshots.</li>
                        <li>Keep gallery description short and inviting.</li>
                    </ul>
                </div>
            </Section>

            <Section title="Layout / Seating Plan (Optional)" hint="Upload a hall/ground layout image if needed.">
                <Uploader
                    label="Layout Image"
                    progress={uploadProgress["layout"] > 0}
                    onFile={handleLayoutImageFile}
                    previewUrl={form.layoutImage}
                    onClear={() => onChange("layoutImage", "")}
                />
            </Section>
            </>
            )}

            {currentStep.id === "additional" && (
            <>
            <Section
                title="Terms & conditions"
                hint="Share requisite terms & conditions regarding your event so people are aware of them. You can either select a template or edit the preset list, except for the last point."
                complete={stepComplete.additional}
                required
            >
                <Select
                    label="Terms & conditions template"
                    value={form.tncTemplate || "default"}
                    onChange={applyTncTemplate}
                    options={TNC_TEMPLATES.map((t) => t.value)}
                    optionLabels={Object.fromEntries(TNC_TEMPLATES.map((t) => [t.value, t.label]))}
                />
                <div>
                    <Label>Terms content</Label>
                    <div className="mt-1">
                        <RichText
                            label=""
                            value={form.termsHtml || ""}
                            onChange={onTermsHtmlChange}
                            placeholder="Add terms & conditions for your event…"
                            minHeight={280}
                        />
                    </div>
                </div>
            </Section>

            <Section
                title="Frequently Asked Questions (FAQs) (Optional)"
                hint="Share Frequently Asked Questions (FAQs) about your event to help answer queries people may have."
                complete={(form.faqs || []).some((f) => String(f.question || "").trim())}
                headerAction={
                    <button
                        type="button"
                        onClick={() => addArrayItem("faqs", { question: "", answer: "" })}
                        className="text-sm font-semibold text-amber-700 hover:text-amber-800"
                    >
                        + Add section
                    </button>
                }
            >
                {(form.faqs || []).length === 0 ? (
                    <p className="text-sm text-slate-500">No FAQs added yet. Click “+ Add section” to create one.</p>
                ) : (
                    <div className="space-y-4">
                        {form.faqs.map((faq, i) => (
                            <div key={i} className="rounded-xl border border-slate-200 bg-slate-50/50 p-4">
                                <div className="mb-3 flex items-center justify-between gap-2">
                                    <p className="text-sm font-semibold text-slate-800">FAQ {i + 1}</p>
                                    <IconButton label="Remove FAQ" onClick={() => removeArrayItem("faqs", i)}>
                                        <FaTrash />
                                    </IconButton>
                                </div>
                                <Input
                                    label="Question"
                                    value={faq.question}
                                    onChange={(v) => onArrayChange("faqs", i, "question", v)}
                                    placeholder="e.g. What is the entry age?"
                                />
                                <div className="mt-3">
                                    <Label>Answer</Label>
                                    <textarea
                                        className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                                        rows={3}
                                        value={faq.answer}
                                        onChange={(e) => onArrayChange("faqs", i, "answer", e.target.value)}
                                        placeholder="Write a clear answer…"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Section>

            <Section
                title="You Should Know (Optional)"
                hint="Share critical or important information about your event that people need to know."
                complete={(form.youShouldKnow || []).some((y) => String(y.title || "").trim() || String(y.body || "").trim())}
                headerAction={
                    <button
                        type="button"
                        onClick={() => addArrayItem("youShouldKnow", { title: "", body: "" })}
                        className="text-sm font-semibold text-amber-700 hover:text-amber-800"
                    >
                        + Add section
                    </button>
                }
            >
                {(form.youShouldKnow || []).length === 0 ? (
                    <p className="text-sm text-slate-500">No notes added yet. Click “+ Add section” to create one.</p>
                ) : (
                    <div className="space-y-4">
                        {form.youShouldKnow.map((item, i) => (
                            <div key={i} className="rounded-xl border border-slate-200 bg-slate-50/50 p-4">
                                <div className="mb-3 flex items-center justify-between gap-2">
                                    <p className="text-sm font-semibold text-slate-800">Note {i + 1}</p>
                                    <IconButton label="Remove note" onClick={() => removeArrayItem("youShouldKnow", i)}>
                                        <FaTrash />
                                    </IconButton>
                                </div>
                                <Input
                                    label="Title"
                                    value={item.title}
                                    onChange={(v) => onArrayChange("youShouldKnow", i, "title", v)}
                                    placeholder="e.g. Gate opens at 5 PM"
                                />
                                <div className="mt-3">
                                    <Label>Details</Label>
                                    <textarea
                                        className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                                        rows={3}
                                        value={item.body}
                                        onChange={(e) => onArrayChange("youShouldKnow", i, "body", e.target.value)}
                                        placeholder="Write important information…"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Section>

            <Section
                title="Ticket Sales Notification (Optional)"
                hint="Receive email updates for your event ticket sale. Notifications sent daily at 8AM and 8PM."
                tone="warn"
                complete={false}
            >
                <Toggle
                    label="Enable ticket sales notification"
                    checked={!!form.ticketSalesNotification}
                    onChange={(v) => onChange("ticketSalesNotification", v)}
                />
            </Section>

            {/* Keep organizer / partners available under Additional info */}
            <Section title="Organizer (Optional)" hint="Organizer details & branding.">
                <div className="grid gap-4 md:grid-cols-2">
                    {Object.keys(form.organizer)
                        .filter((k) => k !== "logoUrl")
                        .map((k) => (
                            <Input
                                key={k}
                                label={capitalize(k)}
                                value={form.organizer[k]}
                                onChange={(v) => onNestedChange("organizer", k, v)}
                            />
                        ))}
                </div>
                <Uploader
                    label="Organizer Logo"
                    progress={uploadProgress["organizer"] > 0}
                    onFile={handleOrganizerLogoFile}
                    previewUrl={form.organizer.logoUrl}
                    onClear={() => onNestedChange("organizer", "logoUrl", "")}
                />
            </Section>

            <Section title="Sponsors (Optional)" hint="Add partner logos and types.">
                {form.sponsors.map((s, i) => (
                    <div key={i} className="rounded-xl border p-4 bg-amber-50/40">
                        <div className="grid gap-4 md:grid-cols-2">
                            <Input
                                label="Name"
                                value={s.name}
                                onChange={(v) => onArrayChange("sponsors", i, "name", v)}
                            />
                            <Select
                                label="Type"
                                value={s.type}
                                onChange={(v) => onArrayChange("sponsors", i, "type", v)}
                                options={[
                                    "Title Sponsor",
                                    "Presenting Sponsor",
                                    "Powered By Sponsor",
                                    "Associate Sponsor",
                                    "Official Partner",
                                    "Venue Partner",
                                    "Digital Media Partner",
                                    "Social Media Partner",
                                ]}
                            />
                        </div>
                        <Textarea
                            label="Description"
                            value={s.description}
                            onChange={(v) => onArrayChange("sponsors", i, "description", v)}
                            rows={3}
                        />
                        <Uploader
                            label="Logo"
                            progress={uploadProgress[`sponsor-${i}`] > 0}
                            onFile={(e) => handleSponsorLogoFile(e, i)}
                            previewUrl={s.logo}
                            onClear={() => onArrayChange("sponsors", i, "logo", "")}
                            inputId={`sponsor-logo-upload-${i}`}
                        />
                        <div className="mt-3">
                            <DangerButton onClick={() => removeArrayItem("sponsors", i)}>
                                <FaTrash /> Remove Sponsor
                            </DangerButton>
                        </div>
                    </div>
                ))}
                <PrimaryGhost
                    onClick={() =>
                        addArrayItem("sponsors", {
                            name: "",
                            logo: "",
                            description: "",
                            type: "Title Sponsor",
                        })
                    }
                >
                    <FaPlus /> Add Sponsor
                </PrimaryGhost>
            </Section>

            {showAdminPublish && (
            <>
            <Section title="GST" hint="GST and convenience fee for this event (superadmin edit only).">
                <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
                    <input
                        type="number"
                        step="any"
                        min="0"
                        placeholder="GST % (e.g. 18)"
                        value={form.gstRatePercent}
                        onChange={(e) => onChange("gstRatePercent", e.target.value)}
                        className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100 sm:max-w-[8rem]"
                    />
                    <select
                        value={form.conveniencesFeeType}
                        onChange={(e) => onChange("conveniencesFeeType", e.target.value)}
                        className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100 sm:max-w-[14rem]"
                    >
                        <option value="convenienceFeeFlat">Conveniences Fee Flat</option>
                        <option value="convenienceFeePercent">Conveniences Fee Percentage</option>
                    </select>
                    <input
                        type="number"
                        step="any"
                        min="0"
                        placeholder={
                            form.conveniencesFeeType === "convenienceFeePercent"
                                ? "Enter % (e.g. 10)"
                                : "Enter amount (e.g. 50)"
                        }
                        value={
                            form.conveniencesFeeType === "convenienceFeePercent"
                                ? form.convenienceFeePercent
                                : form.convenienceFeeFlat
                        }
                        onChange={(e) =>
                            onChange(
                                form.conveniencesFeeType === "convenienceFeePercent"
                                    ? "convenienceFeePercent"
                                    : "convenienceFeeFlat",
                                e.target.value
                            )
                        }
                        className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100"
                    />
                </div>
            </Section>

            <Section title="Other Details" hint="Operational flags (superadmin edit only).">
                <div className="grid gap-4 md:grid-cols-2">
                    <Select
                        label="Status"
                        value={form.status}
                        onChange={(v) => onChange("status", v)}
                        options={["Upcoming", "Live", "Ended", "Cancelled", "Past"]}
                    />
                    <Input label="Remark" value={form.remark} onChange={(v) => onChange("remark", v)} />
                </div>
                <div className="mt-3 grid gap-3 sm:grid-cols-3">
                    <Toggle label="Premium" checked={form.isVerified} onChange={(v) => onChange("isVerified", v)} />
                    <Toggle label="Booking Open" checked={form.isBookingOpen} onChange={(v) => onChange("isBookingOpen", v)} />
                    <Toggle label="Active" checked={form.isActived} onChange={(v) => onChange("isActived", v)} />
                </div>
            </Section>
            </>
            )}

            {!isSuperadmin && (
                <div className="rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
                    {isEditMode
                        ? "Saving changes resubmits this event for approval. Publishing flags are managed by superadmins."
                        : "Your event will stay unpublished with booking disabled until a superadmin approves it."}
                </div>
            )}
            </>
            )}

            {/* Sticky footer actions */}
            <div className="sticky bottom-3 z-10">
                <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-md">
                    <button
                        type="button"
                        onClick={goPrevStep}
                        className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
                        disabled={loading}
                    >
                        <FaArrowLeft /> Back
                    </button>

                    <div className="flex flex-wrap items-center gap-3">
                        {!isLastStep && (
                            <span className="hidden text-sm text-slate-500 sm:inline">
                                Step {stepIndex + 1} of {CREATE_EVENT_STEPS.length}
                            </span>
                        )}
                        <button
                            type="submit"
                            className={cn(
                                "rounded-lg bg-amber-400 px-6 py-2.5 text-sm font-bold text-slate-900 hover:bg-amber-500 transition-colors",
                                loading && "opacity-60 cursor-wait"
                            )}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="inline-flex items-center gap-2">
                                    <FaSpinner className="animate-spin" /> {isEditMode ? "Updating…" : "Submitting…"}
                                </span>
                            ) : isLastStep ? (
                                isEditMode
                                    ? (isSuperadmin ? "Update Event" : "Resubmit for Approval")
                                    : (isSuperadmin ? "Create Event" : "Submit for Review")
                            ) : (
                                "Save & Proceed"
                            )}
                        </button>
                    </div>
                </div>
            </div>

                    </div>
                </form>
            </div>
        </div>
    );
}

/* ========================= Address Picker ========================= */
function AddressPicker({ value, onPick }) {
    const [q, setQ] = useState(value?.address || "");
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);
    const [open, setOpen] = useState(false);
    const debounced = useDebouncedValue(q, 300);
    const boxRef = useRef(null);

    useEffect(() => {
        setQ(value?.address || "");
    }, [value?.address]);

    useEffect(() => {
        let alive = true;
        (async () => {
            if (!debounced || debounced.trim().length < 3) {
                setResults([]);
                return;
            }
            setLoading(true);
            try {
                const arr = await nominatimSearch(debounced, { limit: 6 });
                if (!alive) return;
                setResults(arr || []);
                setOpen(true);
            } catch (e) {
                console.error(e);
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => {
            alive = false;
        };
    }, [debounced]);

    // click outside to close
    useEffect(() => {
        const onClick = (e) => {
            if (!boxRef.current) return;
            if (!boxRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onClick);
        return () => document.removeEventListener("mousedown", onClick);
    }, []);

    const handlePick = (osm) => {
        const patch = normalizeAddress(osm);
        onPick?.(patch);
        setQ(patch.address || "");
        setOpen(false);
    };

    const useMyLocation = () => {
        if (!navigator.geolocation) {
            toast.warn("Geolocation not supported in this browser.");
            return;
        }
        setLoading(true);
        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                try {
                    const { latitude, longitude } = pos.coords;
                    const osm = await nominatimReverse(latitude, longitude);
                    const patch = normalizeAddress(osm);
                    onPick?.(patch);
                    setQ(patch.address || "");
                    toast.success("Fetched address from your location 📍");
                } catch (e) {
                    console.error(e);
                    toast.error("Failed to reverse geocode location.");
                } finally {
                    setLoading(false);
                    setOpen(false);
                }
            },
            (err) => {
                console.error(err);
                setLoading(false);
                toast.error("Could not access your location.");
            },
            { enableHighAccuracy: true, timeout: 10000 }
        );
    };

    return (
        <div className="relative" ref={boxRef}>
            <div className="mb-1 flex items-center justify-between">
                <Label required>Find Address</Label>
                <span className="text-xs text-slate-500">* indicates required fields</span>
            </div>
            <div className="mt-1 flex gap-2">
                <div className="relative flex-1">
                    <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                    <input
                        className="pl-9 pr-3 py-2.5 w-full rounded-xl border focus:ring-2 focus:ring-amber-300"
                        placeholder="Search place, venue, street…"
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        onFocus={() => results.length && setOpen(true)}
                        required
                    />
                    {loading && (
                        <FaSpinner className="absolute right-3 top-1/2 -translate-y-1/2 animate-spin text-slate-400" />
                    )}
                </div>

                <button
                    type="button"
                    onClick={useMyLocation}
                    className="inline-flex items-center gap-2 rounded-xl border px-3 py-2.5 text-sm font-semibold hover:bg-slate-50"
                    title="Use my current location"
                >
                    <FaCrosshairs /> Use my location
                </button>
            </div>

            {open && results.length > 0 && (
                <div className="absolute z-20 mt-1 w-full rounded-xl border bg-white shadow-lg max-h-64 overflow-auto">
                    {results.map((r) => (
                        <button
                            type="button"
                            key={`${r.place_id}-${r.lat}-${r.lon}`}
                            onClick={() => handlePick(r)}
                            className="w-full text-left px-3 py-2 hover:bg-amber-50"
                        >
                            <div className="flex items-start gap-2">
                                <FaMapMarkerAlt className="mt-1 text-amber-600" />
                                <div>
                                    <div className="font-semibold text-slate-800">
                                        {r.display_name?.split(",")?.[0] || "Place"}
                                    </div>
                                    <div className="text-xs text-slate-600 truncate">{r.display_name}</div>
                                </div>
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

/* ========================= small bits ========================= */
function Section({ title, hint, required = false, complete = false, tone = "default", headerAction = null, children }) {
    const warn = tone === "warn";
    return (
        <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm md:p-6">
            <div className="mb-4 flex items-start gap-3 border-b border-slate-100 pb-3">
                <span
                    className={cn(
                        "mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full",
                        warn
                            ? "bg-amber-100 text-amber-600"
                            : complete
                              ? "bg-emerald-500 text-white"
                              : "bg-slate-200 text-slate-500"
                    )}
                >
                    {warn ? (
                        <FaExclamationTriangle className="h-3 w-3" />
                    ) : (
                        <FaCheck className="h-3 w-3" />
                    )}
                </span>
                <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-start justify-between gap-2">
                        <h2 className="text-lg font-bold text-slate-900">
                            {title}
                            {required && <span className="text-rose-500"> *</span>}
                        </h2>
                        {headerAction}
                    </div>
                    {hint && <p className="mt-1 text-sm text-slate-500">{hint}</p>}
                </div>
            </div>
            <div className="space-y-4">{children}</div>
        </div>
    );
}

function Label({ children, required = false }) {
    return (
        <label className="block text-sm font-semibold text-slate-700">
            {children}
            {required && <span className="text-rose-500"> *</span>}
        </label>
    );
}

function Input({ label, value, onChange, type = "text", required = false, placeholder, min, disabled }) {
    return (
        <div>
            <Label required={required}>{label}</Label>
            <input
                type={type}
                className="mt-1.5 w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100 disabled:opacity-60"
                value={value}
                min={min}
                onChange={(e) => onChange(e.target.value)}
                required={required}
                placeholder={placeholder}
                aria-label={label}
                disabled={disabled}
            />
        </div>
    );
}

function Textarea({ label, value, onChange, rows = 4, placeholder, required = false }) {
    return (
        <div>
            <Label required={required}>{label}</Label>
            <textarea
                className="mt-1 border w-full rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-amber-300"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                rows={rows}
                placeholder={placeholder}
                aria-label={label}
                required={required}
            />
        </div>
    );
}

function Select({ label, value, onChange, options = [], optionLabels = null, disabled, required = false }) {
    return (
        <div>
            <Label required={required}>{label}</Label>
            <div className="relative mt-1">
                <select
                    className="w-full appearance-none rounded-lg border border-slate-200 px-3 py-2.5 pr-9 text-sm focus:border-amber-400 focus:outline-none focus:ring-2 focus:ring-amber-100 disabled:opacity-60"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    aria-label={label}
                    disabled={disabled}
                    required={required}
                >
                    {options.map((opt) => (
                        <option key={opt} value={opt}>
                            {optionLabels?.[opt] ?? opt}
                        </option>
                    ))}
                </select>
                <svg
                    className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M6 9l6 6 6-6" />
                </svg>
            </div>
        </div>
    );
}

function Uploader({ label, progress, onFile, previewUrl, onClear, inputId, required = false }) {
    const id = inputId || `uploader-${label.replace(/\s+/g, "-").toLowerCase()}`;
    return (
        <div>
            <Label required={required}>{label}</Label>
            <div className="mt-2 flex flex-col md:flex-row items-start md:items-center gap-3">
                <input id={id} type="file" accept={ACCEPTED_IMG.join(",")} className="hidden" onChange={onFile} />
                <label
                    htmlFor={id}
                    className="inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50 cursor-pointer"
                >
                    {progress ? <FaSpinner className="animate-spin" /> : <FaUpload />}
                    {progress ? "Uploading…" : "Upload"}
                </label>

                {previewUrl ? (
                    <>
                        <img src={previewUrl} alt="preview" className="h-16 w-24 object-cover rounded border" />
                        <IconButton label="Remove" onClick={onClear}>
                            <FaTrash />
                        </IconButton>
                    </>
                ) : (
                    <div className="h-16 w-24 grid place-items-center rounded border text-slate-400">
                        <FaImage />
                    </div>
                )}
            </div>
        </div>
    );
}

function Toggle({ label, checked, onChange }) {
    return (
        <div className="flex items-center justify-between rounded-xl border px-4 py-3 bg-white">
            <div className="text-sm font-semibold text-slate-800">{label}</div>
            <label className="relative inline-flex items-center cursor-pointer">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    className="sr-only peer"
                />
                <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
                    <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
                </div>
            </label>
        </div>
    );
}

function IconButton({ children, onClick, label }) {
    return (
        <button
            type="button"
            title={label}
            aria-label={label}
            onClick={onClick}
            className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-slate-50"
        >
            {children}
        </button>
    );
}

function DangerButton({ children, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="inline-flex items-center gap-2 rounded-full border border-rose-300 text-rose-600 px-3 py-2 text-sm font-semibold hover:bg-rose-50"
        >
            {children}
        </button>
    );
}

function PrimaryGhost({ children, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold hover:bg-amber-50"
        >
            {children}
        </button>
    );
}

function GhostButton({ children, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="inline-flex items-center gap-2 text-amber-700 hover:text-amber-900"
        >
            {children}
        </button>
    );
}

function capitalize(s = "") {
    return s.charAt(0).toUpperCase() + s.slice(1);
}
